// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================================================================
 * Landing — 비로그인 진입 페이지 (홈/공지/요금제/강의/고객센터)
 * 디자인: 피그마 GrowFit 2026-04 시안
 * 토큰: variables.css 의 --fg-* 사용
 * ================================================================ */

/* ---------- 공통 레이아웃 ---------- */
.landing {
    min-height: 100vh;
    background: #ffffff;
    color: var(--fg-text-basic);
    font-family: var(--font-sans);
    display: flex;
    flex-direction: column;
}

.landing__main {
    flex: 1 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 24px 80px;
    gap: 160px;
}

.landing__main--narrow {
    padding: 40px 24px 80px;
    gap: 40px;
}

/* ---------- Header ---------- */
.landing-header {
    position: sticky;
    top: 0;
    z-index: 100;
    background: #ffffff;
    border-bottom: 1px solid transparent;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px;
    box-sizing: border-box;
}

.landing-header__logo {
    display: flex;
    align-items: center;
    text-decoration: none;
    color: inherit;
    cursor: pointer;
    background: none;
    border: none;
    padding: 0;
}

.landing-header__logo-img {
    height: 32px;
    width: auto;
    display: block;
}

.landing-header__nav {
    display: flex;
    align-items: center;
    gap: 12px;
}

.landing-header__station {
    display: inline-flex;
    align-items: center;
    margin-right: 4px;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
}

.landing-header__station-img {
    height: 18px;
    width: auto;
    display: block;
}

.landing-header__nav-btn {
    background: #ffffff;
    border: none;
    min-height: 32px;
    padding: 4px 8px;
    border-radius: 4px;
    font-family: var(--font-sans);
    font-weight: 500;
    font-size: 14px;
    color: var(--fg-text-basic);
    cursor: pointer;
    transition: background var(--transition-fast);
}

.landing-header__nav-btn:hover {
    background: #f8f8f8;
}

.landing-header__nav-btn--active {
    background: #f8f8f8;
}

.landing-header__login {
    background: var(--fg-bg-litepp);
    border: none;
    height: 32px;
    padding: 5px 7px 7px;
    border-radius: 4px;
    font-family: var(--font-sans);
    font-weight: 600;
    font-size: 13px;
    color: var(--fg-button-hover);
    cursor: pointer;
    transition: background var(--transition-fast);
}

.landing-header__login:hover {
    background: var(--fg-bg-litepp-hover);
}

/* 햄버거 / 닫기 버튼 / 백드롭 — 데스크탑에서는 모두 숨김 */
.landing-header__burger,
.landing-header__close,
.landing-header__backdrop {
    display: none;
}

.landing-header__burger {
    background: none;
    border: none;
    padding: 6px;
    margin: -6px;
    color: var(--fg-text-basic);
    cursor: pointer;
    line-height: 0;
    border-radius: var(--radius-md);
}

.landing-header__burger:hover {
    background: #f8f8f8;
}

/* ---------- Header · 모바일 (우측 슬라이드 드로어) ---------- */
@media (max-width: 640px) {
    .landing-header { padding: 12px 16px; }
    .landing-header__logo-img { height: 26px; }

    .landing-header__burger {
        display: inline-flex;
    }

    /* 반투명 백드롭 — 열렸을 때만 페이드 인 */
    .landing-header__backdrop {
        display: block;
        position: fixed;
        inset: 0;
        z-index: 110;
        border: none;
        background: rgba(20, 24, 40, 0.4);
        opacity: 0;
        visibility: hidden;
        transition: opacity 0.25s ease, visibility 0.25s ease;
        cursor: default;
    }

    .landing-header__backdrop.is-open {
        opacity: 1;
        visibility: visible;
    }

    /* nav → 우측 드로어 패널 */
    .landing-header__nav {
        position: fixed;
        top: 0;
        right: 0;
        z-index: 120;
        flex-direction: column;
        align-items: stretch;
        gap: 4px;
        width: min(78vw, 300px);
        height: 100%;
        padding: 64px 16px 24px;
        box-sizing: border-box;
        background: #ffffff;
        box-shadow: var(--shadow-xl);
        transform: translateX(100%);
        transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);
        overflow-y: auto;
    }

    .landing-header__nav.is-open {
        transform: translateX(0);
    }

    .landing-header__close {
        display: inline-flex;
        position: absolute;
        top: 14px;
        right: 14px;
        background: none;
        border: none;
        padding: 6px;
        color: var(--fg-text-gray);
        cursor: pointer;
        line-height: 0;
        border-radius: var(--radius-md);
    }

    .landing-header__close:hover {
        background: #f8f8f8;
    }

    .landing-header__nav-btn {
        justify-content: flex-start;
        text-align: left;
        width: 100%;
        min-height: 48px;
        padding: 12px 14px;
        font-size: 16px;
        border-radius: var(--radius-md);
    }

    /* 로그인/홈 — 드로어 하단 풀폭 CTA */
    .landing-header__login {
        height: auto;
        width: 100%;
        margin-top: 12px;
        padding: 14px;
        font-size: 15px;
        text-align: center;
    }
}

/* ---------- Footer ---------- */
.landing-footer {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 80px 24px 40px;
}

.landing-footer__inner {
    display: flex;
    gap: 20px;
    align-items: center;
    flex-wrap: wrap;
}

.landing-footer__link {
    background: none;
    border: none;
    padding: 0;
    font-family: var(--font-sans);
    font-weight: 400;
    font-size: 14px;
    color: var(--fg-text-basic);
    cursor: pointer;
    text-decoration: none;
}

.landing-footer__link:hover {
    text-decoration: underline;
}

.landing-footer__copyright {
    font-family: var(--font-sans);
    font-weight: 400;
    font-size: 14px;
    color: var(--fg-text-basic);
}

/* ---------- Section 공통 ---------- */
.landing-section {
    width: 100%;
    max-width: 1280px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 40px;
}

.landing-section--narrow {
    max-width: 920px;
}

.landing-section__heading {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
    text-align: center;
    width: 100%;
}

.landing-section__title {
    font-family: var(--font-sans);
    font-weight: 800;
    font-size: 40px;
    line-height: 1.2;
    color: var(--fg-text-basic);
    margin: 0;
}

.landing-section__subtitle {
    font-family: var(--font-sans);
    font-weight: 400;
    font-size: 18px;
    line-height: 28px;
    color: var(--fg-text-basic);
    margin: 0;
}

/* ---------- Button - main S ---------- */
.landing-btn-s {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 8px 8px 8px 12px;
    background: var(--fg-bg-card);
    border: 1px solid var(--fg-line);
    border-radius: 8px;
    font-family: var(--font-sans);
    font-weight: 400;
    font-size: 15px;
    line-height: 28px;
    color: var(--fg-text-basic);
    cursor: pointer;
    text-decoration: none;
    transition: background var(--transition-fast);
}

.landing-btn-s:hover {
    background: var(--fg-bg-content);
}

.landing-btn-b {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    background: var(--fg-bg-card);
    border: 1px solid var(--fg-line);
    border-radius: 12px;
    font-family: var(--font-sans);
    font-weight: 400;
    font-size: 18px;
    color: #525252;
    cursor: pointer;
    text-decoration: none;
    transition: background var(--transition-fast);
}

.landing-btn-b:hover {
    background: var(--fg-bg-content);
}

.landing-icon-arr {
    width: 22px;
    height: 22px;
    flex-shrink: 0;
}

/* ====================================================
 * Home
 * ==================================================== */

.landing-home__hero {
    width: 100%;
    max-width: 1280px;
    display: flex;
    flex-direction: column;
    gap: 60px;
    align-items: center;
}

.landing-home__hero-visual {
    position: relative;
    width: 100%;
    box-shadow: 0 45px 30px -28px rgba(0, 0, 0, 0.1);
    border-radius: 16px;
    overflow: hidden;
}

.landing-home__hero-visual-img {
    width: 100%;
    height: auto;
    display: block;
}

.landing-home__hero-intro {
    width: 100%;
    max-width: 1280px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 40px;
}

.landing-home__hero-tagline {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    width: 100%;
}

.landing-home__hero-title {
    font-family: var(--font-sans);
    font-weight: 800;
    font-size: 40px;
    line-height: 1.2;
    color: var(--fg-text-basic);
    text-align: center;
    margin: 0;
}

.landing-home__hero-desc {
    font-family: var(--font-sans);
    font-weight: 400;
    font-size: 18px;
    line-height: 28px;
    color: var(--fg-text-basic);
    text-align: center;
    margin: 0;
}

.landing-home__model-row {
    display: flex;
    gap: 20px;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
}

.landing-home__model-icon {
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: var(--fg-text-basic);
}

.landing-home__banner-row {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 920px;
    max-width: 100%;
}

.landing-home__banner-card {
    position: relative;
    min-width: 0;
    width: 100%;
    border-radius: var(--radius-2xl);
    overflow: hidden;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    transition: transform var(--transition-fast);
    display: block;
}

.landing-home__banner-card:hover {
    /* transform: translateY(-2px); */
}

.landing-home__banner-card img {
    width: 100%;
    height: auto;
    display: block;
}

html {
    scrollbar-gutter: stable;
}

/* Station 섹션 — 피그마: w-full (전체 너비)
 * .landing__main의 24px 패딩을 깨고 viewport 100%까지 확장 */
.landing-home__station {
    width: 100vw;
    margin-left: calc(50% - 50vw);
    margin-right: calc(50% - 50vw);
    display: flex;
    flex-direction: column;
    gap: 40px;
    align-items: center;
}

.landing-home__station>.landing-section__heading {
    max-width: 1280px;
    padding: 0 24px;
    box-sizing: border-box;
}

.landing-home__station-logo-img {
    height: 42px;
    width: auto;
    display: block;
}

.landing-home__station-slider {
    position: relative;
    width: 100%;
    max-width: 1840px;
    margin: 0 auto;
    overflow: visible;
}

.landing-home__station-track {
    display: flex;
    gap: 32px;
    justify-content: center;
    overflow-x: auto;
    overflow-y: visible;
    padding: 20px 24px 40px;
    scroll-snap-type: x mandatory;
    scrollbar-width: none;
}

.landing-home__station-track::-webkit-scrollbar {
    display: none;
}

.station-card {
    flex-shrink: 0;
    width: 280px;
    height: 540px;
    padding: 20px;
    background: #effafa;
    border-radius: 16px;
    box-shadow: 0 11px 10.2px -10px rgba(0, 0, 0, 0.16);
    display: flex;
    flex-direction: column;
    gap: 12px;
    overflow: hidden;
    cursor: pointer;
    transition: transform var(--transition-fast), box-shadow var(--transition-fast), background var(--transition-fast);
    scroll-snap-align: start;
    box-sizing: border-box;
}

.station-card:hover {
    background: #effbfb;
    /* box-shadow: 0 34px 26px -20px rgba(0, 0, 0, 0.08);
    transform: translateY(-2px); */
}

.station-card__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 48px;
}

.station-card__avatar {
    width: 48px;
    height: 48px;
    display: block;
    flex-shrink: 0;
    object-fit: contain;
}

.station-card__actions {
    display: flex;
    align-items: center;
    gap: 4px;
}

.station-card__like-count {
    font-family: var(--font-sans);
    font-size: 15px;
    line-height: 28px;
    color: var(--fg-anti-red);
}

.station-card__like-btn {
    width: 32px;
    height: 32px;
    padding: 2px;
    background: transparent;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: var(--fg-text-gray);
}

.station-card__like-btn--active {
    color: var(--fg-anti-red);
}

.station-card__body {
    display: flex;
    flex-direction: column;
    gap: 12px;
    height: 376px;
    width: 100%;
    color: var(--fg-text-basic);
    overflow: hidden;
}

.station-card__title {
    font-family: var(--font-sans);
    font-weight: 600;
    font-size: 28px;
    line-height: 40px;
    color: var(--fg-text-basic);
    margin: 0;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
}

.station-card__smr {
    font-family: var(--font-sans);
    font-weight: 400;
    font-size: 14px;
    line-height: normal;
    color: var(--fg-text-basic);
    margin: 0;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
}

.landing-home__slider-arr {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 42px;
    height: 42px;
    border-radius: 21px;
    background: var(--fg-bg-card);
    border: none;
    box-shadow: 0 2px 3.25px rgba(0, 0, 0, 0.09);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 2;
    color: var(--fg-text-basic);
}

.landing-home__slider-arr--left {
    left: -21px;
}

.landing-home__slider-arr--right {
    right: -21px;
}

/* Foundation/Application/Mastery 섹션 */
.landing-home__stats {
    width: 100%;
    max-width: 1280px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 40px;
}

.landing-home__stats-list {
    display: flex;
    gap: 40px;
    align-items: flex-start;
    justify-content: center;
    flex-wrap: wrap;
}

.landing-home__stat {
    min-width: 110px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
}

.landing-home__stat-num {
    font-family: var(--font-sans);
    color: var(--fg-button);
    font-size: 64px;
    line-height: 1;
    margin: 0;
}

.landing-home__stat-num--main {
    font-weight: 800;
}

.landing-home__stat-num--unit {
    font-weight: 100;
    margin-left: 2px;
}

.landing-home__stat-label {
    font-family: var(--font-sans);
    font-weight: 300;
    font-size: 20px;
    color: var(--fg-text-basic);
    margin: 0;
}

.landing-home__stages {
    width: 100%;
    display: flex;
    gap: 40px;
    align-items: flex-start;
    flex-wrap: wrap;
}

.landing-stage {
    flex: 1 1;
    min-width: 280px;
    padding-top: 20px;
    border-top: 4px solid var(--stage-color, var(--fg-numbering-bg));
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.landing-stage--foundation {
    --stage-color: var(--fg-numbering-bg);
}

.landing-stage--application {
    --stage-color: var(--fg-button);
}

.landing-stage--mastery {
    --stage-color: #ff7700;
}

.landing-stage__label {
    font-family: var(--font-sans);
    font-weight: 700;
    font-size: 14px;
    color: var(--stage-color);
    margin: 0;
}

.landing-stage__title {
    font-family: var(--font-sans);
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
    color: var(--fg-text-basic);
    margin: 0;
}

.landing-stage__desc {
    font-family: var(--font-sans);
    font-weight: 400;
    font-size: 15px;
    line-height: 28px;
    color: var(--fg-text-basic);
    margin: 0;
}

.landing-stage__list {
    margin: 0;
    padding-left: 22px;
    font-family: var(--font-sans);
    font-weight: 400;
    font-size: 15px;
    line-height: 28px;
    color: var(--fg-text-basic);
}

/* Features 캐러셀 (그로우핏에서 모든 AI 학습…) */
.landing-home__features {
    width: 100%;
    max-width: 1280px;
    display: flex;
    flex-direction: column;
    gap: 40px;
    align-items: center;
    position: relative;
}

.landing-home__feature-slider {
    position: relative;
    width: 100%;
}

.landing-home__feature-viewport {
    width: 100%;
    overflow: hidden;
    border-radius: 16px;
}

.landing-home__feature-track {
    display: flex;
    width: 100%;
    transition: transform 0.45s cubic-bezier(0.4, 0, 0.2, 1);
    will-change: transform;
}

.landing-home__feature-card {
    flex: 0 0 100%;
    width: 100%;
    height: 560px;
    background: var(--fg-bg-card);
    display: flex;
    gap: 32px;
    overflow: hidden;
    box-sizing: border-box;
    border: 1px solid #DBDBDB;
    border-radius: 16px;
}

.landing-home__feature-text {
    width: 400px;
    flex-shrink: 0;
    padding: 40px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
}

.landing-home__feature-icon {
    width: 36px;
    height: 36px;
    color: var(--fg-button-hover);
}

.landing-home__feature-title {
    font-family: var(--font-sans);
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
    color: var(--fg-text-basic);
    margin: 0;
}

.landing-home__feature-desc {
    font-family: var(--font-sans);
    font-weight: 400;
    font-size: 15px;
    line-height: 28px;
    color: var(--fg-text-basic);
    margin: 0;
}

.landing-home__feature-tags {
    display: flex;
    gap: 4px;
    flex-wrap: wrap;
}

.landing-home__feature-tag {
    background: var(--fg-bg-litepp);
    padding: 4px 8px;
    border-radius: 4px;
    font-family: var(--font-sans);
    font-weight: 400;
    font-size: 12px;
    color: var(--fg-text-basic);
}

.landing-home__feature-visual {
    flex: 1 1;
    position: relative;
    background: linear-gradient(135deg, #e8eaf5 0%, #d5d9eb 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--fg-button-hover);
    font-weight: 600;
    font-size: 18px;
    padding: 24px;
    text-align: center;
    overflow: hidden;
}

.landing-home__feature-visual-img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

/* Class cards (배우고 이해하고 실습하는 다양한 강의) */
.landing-classes-grid {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
}

/* ---- Class cards (피그마 1:25014 시안) ----
 * 각 카드는 PNG가 전체 배경. 텍스트는 PNG의 빈 영역에 절대 좌표로 배치.
 * background-image 절대경로 url()은 CRA css-loader 모듈해석을 유발하므로
 * JSX의 inline style로 설정한다. */
.landing-class-card {
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 160px;
    border: none;
    border-radius: 12px;
    padding: 0;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    cursor: pointer;
    transition: transform var(--transition-fast);
    text-align: left;
    color: var(--fg-text-basic);
    font-family: var(--font-sans);
}

.landing-class-card:hover {
    /* transform: translateY(-2px); */
}

/* 7) 파트너 와이드 배너 (920×200) */
.landing-class-card--partner {
    grid-column: 1 / -1;
    height: 200px;
}

/* Foundation features 2x3 grid */
.landing-home__feature-grid {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 40px;
}

.feature-tile {
    padding-top: 20px;
    border-top: 4px solid var(--tile-color, var(--fg-numbering-bg));
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.feature-tile--cyan {
    --tile-color: var(--fg-numbering-bg);
    --tile-bg: #eefcff;
}

.feature-tile--purple {
    --tile-color: var(--fg-button);
    --tile-bg: #f0f2ff;
}

.feature-tile--green {
    --tile-color: #abd89c;
    --tile-bg: #ebf6e7;
}

.feature-tile--orange {
    --tile-color: #ff7700;
    --tile-bg: #fdf3ea;
}

.feature-tile--blue {
    --tile-color: #86beff;
    --tile-bg: #eff5fd;
}

.feature-tile--pink {
    --tile-color: #ef8da6;
    --tile-bg: #ffeff3;
}

.feature-tile__label {
    font-family: var(--font-sans);
    font-weight: 700;
    font-size: 14px;
    color: var(--tile-color);
    margin: 0;
}

.feature-tile__title {
    font-family: var(--font-sans);
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
    color: var(--fg-text-basic);
    margin: 0;
}

.feature-tile__desc {
    font-family: var(--font-sans);
    font-weight: 400;
    font-size: 15px;
    line-height: 28px;
    color: var(--fg-text-basic);
    margin: 0;
}

.feature-tile__tag {
    display: inline-flex;
    align-self: flex-start;
    background: var(--tile-bg);
    padding: 4px 8px;
    border-radius: 4px;
    font-family: var(--font-sans);
    font-weight: 400;
    font-size: 12px;
    color: var(--fg-text-basic);
}

/* CTA 배너 */
.landing-home__cta {
    width: 100%;
    max-width: 1280px;
    background-image: linear-gradient(104deg, #118bad 0%, #402d6e 100%);
    border-radius: 16px;
    padding: 60px 40px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
}

.landing-home__cta-title {
    font-family: var(--font-sans);
    font-size: 40px;
    color: #ffffff;
    text-align: center;
    margin: 0;
}

.landing-home__cta-title-weak {
    font-weight: 200;
}

.landing-home__cta-title-medium {
    font-weight: 500;
}

.landing-home__cta-title-bold {
    font-weight: 800;
}

.landing-home__cta-logo {
    height: 90px;
    width: auto;
}

/* ====================================================
 * Notice
 * ==================================================== */
.landing-notice {
    width: 100%;
    max-width: 760px;
    display: flex;
    flex-direction: column;
    gap: 40px;
}

.landing-page-title {
    font-family: var(--font-sans);
    font-weight: 600;
    font-size: 28px;
    line-height: 40px;
    color: var(--fg-text-basic);
    text-align: center;
    margin: 0;
}

/* ---------- Legal (이용약관 / 개인정보 처리방침) ---------- */
.landing-legal {
    width: 100%;
    max-width: 760px;
    display: flex;
    flex-direction: column;
    gap: 40px;
}

.landing-legal__head {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 4px;
}

.landing-legal__title {
    font-family: var(--font-sans);
    font-weight: 600;
    font-size: 28px;
    line-height: 40px;
    color: var(--fg-text-basic);
    margin: 0;
}

.landing-legal__help {
    display: inline-flex;
    align-items: center;
    color: var(--fg-text-gray);
}

.landing-legal__body {
    width: 100%;
    font-family: var(--font-sans);
    font-weight: 400;
    font-size: 16px;
    line-height: 26px;
    color: var(--fg-text-basic);
    word-break: break-word;
}

.landing-legal__meta {
    margin: 0;
    font-size: 16px;
    line-height: 26px;
    color: var(--fg-text-basic);
}

.landing-legal__body h2 {
    margin: 28px 0 8px;
    font-family: var(--font-sans);
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
    color: var(--fg-text-basic);
}

.landing-legal__body h2:first-of-type {
    margin-top: 8px;
}

.landing-legal__body p {
    margin: 0;
    font-size: 16px;
    line-height: 26px;
    color: var(--fg-text-basic);
}

.landing-legal__body ul {
    margin: 0;
    padding-left: 22px;
    list-style: disc;
}

.landing-legal__body li {
    margin: 0;
    font-size: 16px;
    line-height: 26px;
    color: var(--fg-text-basic);
}

.landing-notice__toolbar {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
}

.landing-category-tabs {
    display: flex;
    align-items: center;
    max-width: 100%;
    overflow-x: auto;
    scrollbar-width: none;
}

.landing-category-tabs::-webkit-scrollbar {
    display: none;
}

.landing-category-tab {
    background: transparent;
    border: none;
    border-bottom: 2px solid transparent;
    padding: 10px;
    display: inline-flex;
    align-items: center;
    gap: 3px;
    cursor: pointer;
    font-family: var(--font-sans);
    flex-shrink: 0;
    white-space: nowrap;
}

.landing-category-tab__title {
    font-weight: 600;
    font-size: 14px;
    color: var(--fg-text-basic);
    margin: 0;
}

.landing-category-tab__count {
    font-weight: 400;
    font-size: 13px;
    color: var(--fg-text-gray);
    margin: 0;
}

.landing-category-tab--active {
    border-bottom-color: var(--fg-text-basic);
}

.landing-search {
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    background: #ffffff;
    border: 1px solid var(--fg-line);
    border-radius: 30px;
    padding: 7px 12px 7px 20px;
    width: 240px;
}

.landing-search__input {
    flex: 1 1;
    border: none;
    background: transparent;
    outline: none;
    font-family: var(--font-sans);
    font-weight: 400;
    font-size: 16px;
    line-height: 26px;
    color: var(--fg-text-basic);
    width: calc(100% - 28px);
}

.landing-search__input::placeholder {
    color: var(--fg-text-gray);
}

.landing-search__icon {
    width: 24px;
    height: 24px;
    color: var(--fg-text-gray);
    flex-shrink: 0;
}

.landing-notice__list {
    width: 100%;
    border-top: 1px solid var(--fg-text-basic);
    display: flex;
    flex-direction: column;
}

.landing-notice__item {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 20px 12px;
    border-bottom: 1px solid var(--fg-line);
    background: #ffffff;
    cursor: pointer;
    transition: background var(--transition-fast);
    text-align: left;
    border-left: none;
    border-right: none;
    border-top: none;
}

.landing-notice__item:hover {
    background: var(--fg-bg-card);
}

.landing-notice__item--pinned {
    background: #f8f9ff;
}

.landing-notice__meta {
    width: 136px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
    text-align: center;
    align-items: center;
}

.landing-notice__pin-tag {
    font-family: var(--font-sans);
    font-weight: 500;
    font-size: 14px;
    color: var(--fg-numbering-bg-current);
    margin: 0;
}

.landing-notice__cat {
    font-family: var(--font-sans);
    font-weight: 500;
    font-size: 14px;
    color: var(--fg-button);
    margin: 0;
}

.landing-notice__body {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 0;
}

.landing-notice__title {
    font-family: var(--font-sans);
    font-weight: 600;
    font-size: 16px;
    color: var(--fg-text-basic);
    margin: 0;
}

.landing-notice__smr {
    font-family: var(--font-sans);
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: var(--fg-text-basic);
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.landing-notice__date {
    width: 100px;
    flex-shrink: 0;
    text-align: right;
    font-family: var(--font-sans);
    font-weight: 400;
    font-size: 14px;
    color: var(--fg-text-gray);
    margin: 0;
}

/* 리스트 아이템 우측 부가정보(날짜 + 조회수) 컬럼 */
.landing-notice__aside {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
    width: 100px;
    flex-shrink: 0;
}

.landing-notice__aside .landing-notice__date {
    width: auto;
}

.landing-notice__views {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: var(--fg-text-gray);
}

.landing-notice__share-btn {
    background: transparent;
    border: none;
    width: 28px;
    height: 28px;
    padding: 0;
    margin-left: 4px;
    border-radius: 4px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: var(--fg-text-gray);
    transition: background var(--transition-fast), color var(--transition-fast);
}

.landing-notice__share-btn:hover {
    background: var(--fg-bg-card);
    color: var(--fg-text-basic);
}

/* ---------- 공지사항 · 모바일 ---------- */
@media (max-width: 640px) {
    /* 본문 컬럼 폭 확보 — 공유 메인 좌우 패딩 축소 */
    .landing__main,
    .landing__main--narrow {
        padding-left: 16px;
        padding-right: 16px;
    }
    /* 리스트 아이템 — 세로 카드로 재배치(고정폭 meta·날짜가 본문을 압박하지 않도록) */
    .landing-notice__item {
        flex-direction: column;
        align-items: stretch;
        gap: 8px;
        padding: 16px 10px;
    }
    .landing-notice__meta {
        width: auto;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        text-align: left;
        gap: 8px;
    }
    /* 날짜·조회수 — 본문 아래 가로 한 줄로 */
    .landing-notice__aside {
        width: auto;
        flex-direction: row;
        align-items: center;
        align-self: flex-start;
        gap: 10px;
    }
    .landing-notice__date {
        text-align: left;
    }
    /* 검색창 풀폭 */
    .landing-search {
        width: 100%;
    }
}

/* 공지 상세 본문 — 관리자 ReactQuill(Quill 2) 에디터 출력과 동일하게 렌더
 * 관리자가 작성한 내용은 getSemanticHTML 결과로 저장되며, 줄바꿈/문단 간격은
 * 에디터(.ql-editor: 14px / line-height 1.6 / 블록요소 margin 0)에 의해 결정됨.
 * 줄바꿈 일치를 위해 동일한 기준값과 margin 모델을 그대로 따른다. */
.landing-notice__detail-body {
    font-family: var(--font-sans);
    font-size: 14px;
    line-height: 1.6;
    color: var(--fg-text-basic);
    word-break: break-word;
}

/* Quill: 블록 요소는 margin/padding 0 → 줄 간격은 빈 문단(<p><br></p>)으로만 생김 */
.landing-notice__detail-body p,
.landing-notice__detail-body ol,
.landing-notice__detail-body ul,
.landing-notice__detail-body pre,
.landing-notice__detail-body blockquote,
.landing-notice__detail-body h1,
.landing-notice__detail-body h2,
.landing-notice__detail-body h3,
.landing-notice__detail-body h4,
.landing-notice__detail-body h5,
.landing-notice__detail-body h6 {
    margin: 0;
    padding: 0;
}

/* 빈 문단(<p></p>) — getSemanticHTML은 빈 줄에서 <br>을 제거하므로 높이가 0이 됨.
 * 에디터의 빈 줄(한 줄 높이)과 동일하게 보이도록 한 줄 높이를 부여 */
.landing-notice__detail-body p:empty {
    min-height: 1.6em;
}

/* Quill 제목 (em 기준 — 14px base) */
.landing-notice__detail-body h1 {
    font-size: 2em;
    font-weight: 700;
}

.landing-notice__detail-body h2 {
    font-size: 1.5em;
    font-weight: 700;
}

.landing-notice__detail-body h3 {
    font-size: 1.17em;
    font-weight: 700;
}

.landing-notice__detail-body h4 {
    font-size: 1em;
    font-weight: 700;
}

.landing-notice__detail-body h5 {
    font-size: 0.83em;
    font-weight: 700;
}

.landing-notice__detail-body h6 {
    font-size: 0.67em;
    font-weight: 700;
}

/* Quill 리스트 — 불릿은 <ul>(disc), 번호는 <ol>(decimal)로 직렬화됨 */
.landing-notice__detail-body ol,
.landing-notice__detail-body ul {
    padding-left: 1.5em;
}

.landing-notice__detail-body ul {
    list-style: disc;
}

.landing-notice__detail-body ol {
    list-style: decimal;
}

.landing-notice__detail-body li[data-list="checked"],
.landing-notice__detail-body li[data-list="unchecked"] {
    list-style: none;
}

.landing-notice__detail-body a {
    color: var(--fg-link);
    text-decoration: underline;
}

.landing-notice__detail-body a:hover {
    color: var(--fg-link-hover);
}

.landing-notice__detail-body strong,
.landing-notice__detail-body b {
    font-weight: 700;
}

.landing-notice__detail-body em,
.landing-notice__detail-body i {
    font-style: italic;
}

.landing-notice__detail-body u {
    text-decoration: underline;
}

.landing-notice__detail-body s,
.landing-notice__detail-body del {
    text-decoration: line-through;
}

.landing-notice__detail-body mark {
    background: #fff3a3;
    padding: 0 2px;
}

/* Quill blockquote */
.landing-notice__detail-body blockquote {
    border-left: 4px solid #ccc;
    padding-left: 16px;
    margin: 5px 0;
    color: var(--fg-text-gray);
}

/* Quill 코드/코드블록 */
.landing-notice__detail-body code {
    background: #f0f0f0;
    padding: 2px 4px;
    border-radius: 3px;
    font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
    font-size: 0.9em;
}

.landing-notice__detail-body pre {
    background: #f0f0f0;
    padding: 5px 10px;
    border-radius: 3px;
    margin: 5px 0;
    overflow-x: auto;
    white-space: pre-wrap;
    font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
    font-size: 0.9em;
}

.landing-notice__detail-body pre code {
    background: transparent;
    padding: 0;
    font-size: inherit;
}

.landing-notice__detail-body hr {
    border: 0;
    border-top: 1px solid var(--fg-line);
    margin: 16px 0;
}

.landing-notice__detail-body img {
    max-width: 100%;
    height: auto;
}

/* Quill 표 */
.landing-notice__detail-body table {
    border-collapse: collapse;
}

.landing-notice__detail-body th,
.landing-notice__detail-body td {
    border: 1px solid #000;
    padding: 2px 5px;
    vertical-align: top;
}

/* ReactQuill 출력 호환 — align / indent 클래스 (Quill 기본값과 동일) */
.landing-notice__detail-body .ql-align-center {
    text-align: center;
}

.landing-notice__detail-body .ql-align-right {
    text-align: right;
}

.landing-notice__detail-body .ql-align-justify {
    text-align: justify;
}

.landing-notice__detail-body .ql-indent-1 {
    padding-left: 3em;
}

.landing-notice__detail-body .ql-indent-2 {
    padding-left: 6em;
}

.landing-notice__detail-body .ql-indent-3 {
    padding-left: 9em;
}

.landing-notice__detail-body .ql-indent-4 {
    padding-left: 12em;
}

.landing-notice__detail-body .ql-indent-5 {
    padding-left: 15em;
}

.landing-notice__detail-body .ql-indent-6 {
    padding-left: 18em;
}

.landing-notice__detail-body .ql-indent-7 {
    padding-left: 21em;
}

.landing-notice__detail-body .ql-indent-8 {
    padding-left: 24em;
}

.landing-notice__detail-body li.ql-indent-1 {
    padding-left: 4.5em;
}

.landing-notice__detail-body li.ql-indent-2 {
    padding-left: 7.5em;
}

.landing-notice__detail-body li.ql-indent-3 {
    padding-left: 10.5em;
}

.landing-notice__detail-body li.ql-indent-4 {
    padding-left: 13.5em;
}

.landing-notice__detail-body li.ql-indent-5 {
    padding-left: 16.5em;
}

.landing-notice__detail-body li.ql-indent-6 {
    padding-left: 19.5em;
}

.landing-notice__detail-body li.ql-indent-7 {
    padding-left: 22.5em;
}

.landing-notice__detail-body li.ql-indent-8 {
    padding-left: 25.5em;
}

/* 마크다운 폴백 — ReactMarkdown은 빈 문단 없이 <p>만 출력하므로 간격 복원 */
.landing-notice__detail-body--md p {
    margin: 12px 0;
}

.landing-notice__detail-body--md ul,
.landing-notice__detail-body--md ol {
    margin: 12px 0;
}

.landing-notice__detail-body--md h1 {
    margin: 20px 0 10px;
}

.landing-notice__detail-body--md h2 {
    margin: 18px 0 10px;
}

.landing-notice__detail-body--md h3 {
    margin: 14px 0 8px;
}

.landing-notice__detail-body--md h4,
.landing-notice__detail-body--md h5,
.landing-notice__detail-body--md h6 {
    margin: 12px 0 6px;
}

.landing-notice__detail-body--md blockquote {
    margin: 12px 0;
}

.landing-notice__detail-body--md pre {
    margin: 12px 0;
}

.landing-notice__detail-body--md>*:first-child {
    margin-top: 0;
}

.landing-notice__detail-body--md>*:last-child {
    margin-bottom: 0;
}

/* 페이징 */
.landing-paging {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
}

.landing-paging__btn {
    min-width: 32px;
    height: 32px;
    padding: 4px;
    background: var(--fg-bg-card);
    border: 1px solid var(--fg-line);
    border-radius: 4px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-family: var(--font-sans);
    font-weight: 400;
    font-size: 15px;
    line-height: 24px;
    color: var(--fg-text-gray);
}

.landing-paging__btn--active {
    background: var(--fg-button);
    border-color: var(--fg-button);
    color: #ffffff;
}

.landing-paging__btn:disabled {
    cursor: not-allowed;
    opacity: 0.5;
}

.landing-paging__ellipsis {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 32px;
    color: var(--fg-text-gray);
    font-size: 14px;
}

/* ====================================================
 * Price
 * ==================================================== */
.landing-price {
    width: 100%;
    max-width: 920px;
    display: flex;
    flex-direction: column;
    gap: 40px;
}

.landing-price__toggle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
}

.landing-price__seg {
    display: inline-flex;
    align-items: center;
    gap: 1px;
    overflow: hidden;
    border-radius: 4px;
}

.landing-price__seg-btn {
    background: var(--fg-bg-litepp);
    border: none;
    height: 32px;
    padding: 5px 12px 7px;
    font-family: var(--font-sans);
    font-weight: 600;
    font-size: 13px;
    color: var(--fg-button-hover);
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: background var(--transition-fast);
}

.landing-price__seg-btn--active {
    background: var(--fg-button);
    color: #ffffff;
}

.landing-price__seg-note {
    font-family: var(--font-sans);
    font-weight: 500;
    font-size: 14px;
    color: var(--fg-side-hover);
}

.landing-price__plans {
    width: 100%;
    display: flex;
    gap: 20px;
    align-items: stretch;
    flex-wrap: wrap;
}

.landing-plan {
    flex: 1 1;
    min-width: 260px;
    padding: 20px;
    background: var(--fg-bg-card);
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.landing-plan--featured {
    background: var(--fg-bg-liteblue);
}

.landing-plan__role {
    display: flex;
    align-items: center;
    gap: 4px;
}

.landing-plan__role-icon {
    width: 20px;
    height: 20px;
    color: var(--fg-text-basic);
}

.landing-plan__role-name {
    font-family: var(--font-sans);
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    margin: 0;
}

.landing-plan__name {
    font-family: var(--font-sans);
    font-weight: 600;
    font-size: 24px;
    color: var(--fg-text-basic);
    margin: 0;
}

.landing-plan__price {
    display: flex;
    align-items: flex-end;
    gap: 4px;
    color: var(--fg-text-basic);
}

.landing-plan__price-currency {
    font-family: var(--font-sans);
    font-weight: 400;
    font-size: 18px;
    line-height: 28px;
    margin: 0;
}

.landing-plan__price-amount {
    font-family: var(--font-sans);
    font-weight: 600;
    font-size: 36px;
    line-height: 46px;
    margin: 0;
}

.landing-plan__price-period {
    font-family: var(--font-sans);
    font-weight: 400;
    font-size: 14px;
    color: var(--fg-text-basic);
    margin: 0;
}

.landing-plan__cta {
    width: 100%;
    min-height: 44px;
    padding: 12px;
    background: var(--fg-button);
    border: none;
    border-radius: 8px;
    color: #ffffff;
    font-family: var(--font-sans);
    font-weight: 700;
    font-size: 16px;
    cursor: pointer;
    text-align: center;
    transition: background var(--transition-fast);
}

.landing-plan__cta:hover {
    background: var(--fg-button-hover);
}

.landing-plan__pitch {
    font-family: var(--font-sans);
    font-weight: 400;
    font-size: 16px;
    line-height: 26px;
    color: var(--fg-text-basic);
    margin: 0;
}

.landing-plan__features {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin: 0;
    padding: 0;
    list-style: none;
}

.landing-plan__feature {
    display: flex;
    gap: 4px;
    align-items: flex-start;
    font-family: var(--font-sans);
    font-weight: 400;
    font-size: 14px;
    color: var(--fg-text-basic);
}

.landing-plan__feature--highlight {
    font-weight: 500;
    color: var(--fg-anti-red);
}

.landing-plan__feature-icon {
    width: 22px;
    height: 22px;
    flex-shrink: 0;
    color: var(--fg-button);
}

.landing-plan__feature--highlight .landing-plan__feature-icon {
    color: var(--fg-anti-red);
}

/* ====================================================
 * Classes
 * ==================================================== */
.landing-classes {
    width: 100%;
    max-width: 920px;
    display: flex;
    flex-direction: column;
    gap: 40px;
}

.landing-classes__heading {
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.landing-classes__title {
    font-family: var(--font-sans);
    font-weight: 600;
    font-size: 28px;
    line-height: 40px;
    color: var(--fg-text-basic);
    margin: 0;
}

.landing-classes__subtitle-strong {
    font-family: var(--font-sans);
    font-weight: 700;
    font-size: 18px;
    line-height: 28px;
    color: var(--fg-text-basic);
    margin: 0;
}

.landing-classes__subtitle {
    font-family: var(--font-sans);
    font-weight: 400;
    font-size: 18px;
    line-height: 28px;
    color: var(--fg-text-basic);
    margin: 0;
}

.landing-classes__table-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 42px;
    gap: 8px;
    flex-wrap: wrap;
}

.landing-classes__sort {
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    width: 140px;
    background: #ffffff;
    border: 1px solid var(--fg-line);
    border-radius: 8px;
    padding: 8px 8px 8px 16px;
    cursor: pointer;
    font-family: var(--font-sans);
    font-weight: 400;
    font-size: 14px;
    color: var(--fg-text-basic);
}

.landing-classes__table {
    width: 100%;
    display: flex;
    flex-direction: column;
}

.landing-classes__table-head {
    display: flex;
    align-items: center;
    gap: 24px;
    padding: 20px;
    border-bottom: 1px solid var(--fg-text-basic);
    font-family: var(--font-sans);
    font-weight: 500;
    font-size: 14px;
    color: var(--fg-text-basic);
    text-align: center;
}

.landing-classes__th--title {
    flex: 1 1;
    min-width: 0;
    text-align: left;
}

.landing-classes__th--instructor {
    width: 100px;
}

.landing-classes__th--students {
    width: 110px;
}

.landing-classes__row {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 24px;
    padding: 20px;
    border-bottom: 1px solid var(--fg-line);
    background: #ffffff;
    cursor: pointer;
    transition: background var(--transition-fast);
    text-align: left;
    border-left: none;
    border-right: none;
    border-top: none;
}

.landing-classes__row:hover {
    background: var(--fg-bg-card);
}

.landing-classes__col-title {
    flex: 1 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.landing-classes__title-row {
    display: flex;
    align-items: center;
    gap: 6px;
}

.landing-classes__grade-badge {
    border: 1px solid var(--fg-text-basic);
    border-radius: 4px;
    padding: 2px 6px;
    background: #ffffff;
    font-family: var(--font-sans);
    font-weight: 400;
    font-size: 12px;
    color: var(--fg-text-basic);
}

.landing-classes__title-text {
    font-family: var(--font-sans);
    font-weight: 600;
    font-size: 15px;
    line-height: 28px;
    color: var(--fg-text-basic);
}

.landing-classes__smr {
    font-family: var(--font-sans);
    font-weight: 400;
    font-size: 13px;
    line-height: 20px;
    color: var(--fg-text-gray);
    margin: 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.landing-classes__col-instructor {
    width: 100px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 6px;
    overflow: hidden;
}

.landing-classes__avatar {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: linear-gradient(135deg, var(--fg-bg-litepp), #d8dcf2);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: var(--fg-button-hover);
    font-weight: 700;
    font-size: 12px;
}

.landing-classes__instructor-name {
    font-family: var(--font-sans);
    font-weight: 600;
    font-size: 16px;
    color: var(--fg-text-basic);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.landing-classes__col-students {
    width: 110px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0;
    font-family: var(--font-sans);
    font-size: 14px;
    color: var(--fg-text-gray);
    white-space: nowrap;
}

.landing-classes__students-current {
    font-weight: 700;
}

.landing-classes__students-total {
    font-weight: 400;
}

/* ====================================================
 * Support
 * ==================================================== */
.landing-support {
    width: 100%;
    max-width: 760px;
    display: flex;
    flex-direction: column;
    gap: 40px;
}

.landing-support__title-row {
    display: flex;
    align-items: center;
    gap: 4px;
    height: 40px;
}

.landing-support__title {
    font-family: var(--font-sans);
    font-weight: 600;
    font-size: 28px;
    line-height: 40px;
    color: var(--fg-text-basic);
    margin: 0;
}

.landing-support__title-help {
    width: 20px;
    height: 20px;
    color: var(--fg-text-gray);
    cursor: pointer;
}

.landing-support__body {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.landing-support__group {
    background: var(--fg-line);
    border: 1px solid var(--fg-line);
    border-radius: 12px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 1px;
}

.landing-support__row {
    background: #ffffff;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px;
}

.landing-support__row-icon {
    width: 28px;
    height: 28px;
    color: var(--fg-text-basic);
    flex-shrink: 0;
}

.landing-support__row-body {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
}

.landing-support__row-title {
    font-family: var(--font-sans);
    font-weight: 600;
    font-size: 16px;
    color: var(--fg-text-basic);
    margin: 0;
}

.landing-support__row-desc {
    font-family: var(--font-sans);
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: var(--fg-text-basic);
    margin: 0;
}

.landing-support__row-cta {
    background: var(--fg-bg-litepp);
    border: none;
    height: 32px;
    padding: 5px 7px 7px;
    border-radius: 4px;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-family: var(--font-sans);
    font-weight: 600;
    font-size: 13px;
    color: var(--fg-button-hover);
    cursor: pointer;
    text-decoration: none;
    flex-shrink: 0;
}

.landing-support__row-cta-icon {
    width: 16px;
    height: 16px;
}

.landing-support__faq-title {
    font-family: var(--font-sans);
    font-weight: 600;
    font-size: 16px;
    line-height: 26px;
    color: var(--fg-text-basic);
    margin: 0;
}

.landing-support__accordion {
    background: var(--fg-line);
    border: 1px solid var(--fg-line);
    border-radius: 12px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 1px;
}

.landing-support__accordion-item {
    background: #ffffff;
    border: none;
    padding: 16px;
    display: flex;
    align-items: center;
    gap: 12px;
    min-height: 52px;
    cursor: pointer;
    text-align: left;
    transition: background var(--transition-fast);
    font-family: var(--font-sans);
}

.landing-support__accordion-item:hover {
    background: var(--fg-bg-card);
}

.landing-support__accordion-item--open {
    background: #f3fbff;
    flex-direction: column;
    align-items: stretch;
    gap: 20px;
}

.landing-support__accordion-q {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
}

.landing-support__accordion-q-text {
    flex: 1 1;
    font-family: var(--font-sans);
    font-weight: 500;
    font-size: 14px;
    color: var(--fg-text-basic);
    margin: 0;
}

.landing-support__accordion-chev {
    width: 20px;
    height: 20px;
    color: var(--fg-text-basic);
    flex-shrink: 0;
    transition: transform var(--transition-fast);
}

.landing-support__accordion-item--open .landing-support__accordion-chev {
    transform: rotate(180deg);
}

.landing-support__accordion-a {
    font-family: var(--font-sans);
    font-weight: 400;
    font-size: 13px;
    line-height: 22px;
    color: var(--fg-text-gray);
    margin: 0;
    text-align: left;
}

.landing-support__brand {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
}

.landing-support__brand-logos {
    display: flex;
    gap: 20px;
    align-items: center;
}

.landing-support__brand-logo {
    height: 36px;
    width: auto;
}

.landing-support__brand-logo--bct {
    height: 24px;
}

.landing-support__brand-desc {
    font-family: var(--font-sans);
    font-weight: 500;
    font-size: 14px;
    color: var(--fg-text-basic);
    margin: 0;
}

.landing-support__brand-desc strong {
    font-weight: 700;
}

.landing-support__brand-copyright {
    font-family: var(--font-sans);
    font-weight: 400;
    font-size: 14px;
    color: var(--fg-text-basic);
    margin: 0;
}

/* Kakao 문의 FAB & 모달 */
.landing-home__kakao-fab {
    position: fixed;
    right: 24px;
    bottom: 24px;
    width: 64px;
    height: 64px;
    border-radius: var(--radius-full);
    background: none;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 90;
    transition: transform var(--transition-fast);
}

.landing-home__kakao-fab:hover {
    transform: translateY(-2px);
}

.landing-home__kakao-fab:focus-visible {
    outline: none;
    box-shadow: var(--focus-ring);
}

.landing-home__kakao-fab-icon {
    width: 32px;
    height: 32px;
    object-fit: contain;
}

.landing-home__kakao-modal {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
    padding: 16px;
    animation: landing-kakao-fade 0.15s ease-out;
}

@keyframes landing-kakao-fade {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.landing-home__kakao-modal-body {
    position: relative;
    background: var(--surface);
    padding: 32px 32px 24px;
    border-radius: var(--radius-2xl);
    box-shadow: var(--shadow-2xl);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    max-width: 100%;
}

.landing-home__kakao-modal-close {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 32px;
    height: 32px;
    background: none;
    border: none;
    border-radius: var(--radius-md);
    cursor: pointer;
    color: var(--text-secondary);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background var(--transition-fast), color var(--transition-fast);
}

.landing-home__kakao-modal-close:hover {
    background: var(--gray-100);
    color: var(--text-primary);
}

.landing-home__kakao-modal-title {
    margin: 0;
    font-size: 18px;
    font-weight: 700;
    color: var(--text-primary);
}

.landing-home__kakao-modal-img {
    width: 280px;
    height: 280px;
    object-fit: contain;
    display: block;
}

.landing-home__kakao-modal-desc {
    margin: 0;
    font-size: 14px;
    color: var(--text-secondary);
}

/* ====================================================
 * Home(LandingHome) 반응형 — 태블릿/모바일
 * landing-home__* 계열은 기본이 데스크탑 고정값(폰트 40~64px,
 * feature-grid 3열 고정 등)이라 좁은 폭에서 그리드 열·폰트·여백을
 * 단계적으로 축소한다.
 * ==================================================== */

/* 태블릿: 커리큘럼 그리드 3 → 2열 */
@media (max-width: 980px) {
    .landing-home__feature-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 28px;
    }
}

@media (max-width: 640px) {
    /* 섹션 간 간격 축소 (데스크탑 160px → 모바일 80px) */
    .landing__main {
        gap: 80px;
    }

    /* 섹션/히어로 제목·부제 — 40px 고정값은 모바일에서 넘침 */
    .landing-section__title {
        font-size: 26px;
    }

    .landing-section__subtitle {
        font-size: 15px;
        line-height: 24px;
    }

    .landing-home__hero {
        gap: 36px;
    }

    .landing-home__hero-intro {
        gap: 28px;
    }

    .landing-home__hero-title {
        font-size: 26px;
    }

    .landing-home__hero-desc {
        font-size: 15px;
        line-height: 24px;
    }

    .landing-home__model-row {
        gap: 14px;
    }

    /* 통계 — 64px 숫자는 모바일에서 과대, 각 항목 중앙 정렬 */
    .landing-home__stats-list {
        gap: 24px 28px;
    }

    .landing-home__stat {
        min-width: 0;
        align-items: center;
        text-align: center;
    }

    .landing-home__stat-num {
        font-size: 44px;
    }

    .landing-home__stat-label {
        font-size: 16px;
    }

    /* 스테이지 카드 간격 */
    .landing-home__stages {
        gap: 28px;
    }

    /* 커리큘럼 그리드 — 모바일 1열 (기존 repeat(3,1fr) 고정 해제) */
    .landing-home__feature-grid {
        grid-template-columns: 1fr;
        gap: 24px;
    }

    /* CTA 배너 */
    .landing-home__cta {
        padding: 40px 20px;
    }

    .landing-home__cta-title {
        font-size: 26px;
    }

    .landing-home__cta-logo {
        height: 60px;
    }

    /* 카카오 FAB·QR 모달 — 작은 화면 가로 오버플로 방지 */
    .landing-home__kakao-fab {
        right: 16px;
        bottom: 16px;
        width: 56px;
        height: 56px;
    }

    .landing-home__kakao-modal-body {
        padding: 28px 20px 20px;
    }

    .landing-home__kakao-modal-img {
        width: 220px;
        height: 220px;
    }

    /* 둘러보기 슬라이더 — 데스크탑 가로 분할(텍스트 400px + 이미지)을
       모바일에서 세로 스택으로 전환. 고정 400px 텍스트가 줄지 않아
       이미지를 화면 밖으로 밀어내던 문제 해결 */
    .landing-home__feature-card {
        flex-direction: column;
        height: auto;
        gap: 0;
    }

    .landing-home__feature-text {
        width: auto;
        padding: 24px;
    }

    .landing-home__feature-visual {
        flex: none;
        width: 100%;
        height: 200px;
    }

    /* 화살표 — 뷰포트 밖(-21px)으로 나가 잘리던 것을 안쪽으로,
       이미지 영역(하단 200px) 세로 중앙에 배치 */
    .landing-home__slider-arr {
        top: auto;
        bottom: 82px;
        transform: none;
        width: 36px;
        height: 36px;
    }

    .landing-home__slider-arr--left {
        left: 8px;
    }

    .landing-home__slider-arr--right {
        right: 8px;
    }
}

/* ── 랜딩 리포지셔닝: 브랜드 네이비 로컬 토큰 ──
   제품(AgentShowcase .gf-showcase-page)과 동일한 브랜드 네이비를 랜딩 로컬로 정의.
   전역 토큰은 변경하지 않는다(보라 계열 primary / fg-purple 토큰 미사용). */
.landing {
  --lp-navy: #13314f;        /* 브랜드 네이비 */
  --lp-navy-ink: #0e1b2b;    /* 다크 밴드 배경용 near-black 네이비 */
  --lp-navy-soft: #3c5a78;   /* 보조 네이비 */
  --lp-navy-tint: #e7edf3;   /* 배지 등 옅은 네이비 배경 */
  --lp-navy-line: rgba(14, 27, 43, 0.1);  /* 헤어라인 */
  --lp-gov: #1a5e3a;         /* 정부 공급기업 그린 */
  --lp-gov-tint: #e6f1ea;
  --lp-serif: "Newsreader", "Iowan Old Style", Georgia, serif;  /* 에디토리얼 숫자 */
}

/* ── 랜딩 리포지셔닝: 히어로 ── */
.lp-hero {
  padding: 84px 24px 80px;
  background: var(--fg-bg-content, var(--surface));
}
.lp-hero__inner {
  max-width: 880px;
  margin: 0 auto;
  text-align: center;
}
.lp-hero__eyebrow {
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: var(--lp-navy-soft);
  margin: 0 0 16px;
}
.lp-hero__title {
  font-size: 44px;
  line-height: 1.25;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: var(--text-primary);
  margin: 0 0 20px;
}
.lp-hero__title-accent {
  color: var(--lp-navy);
}
.lp-hero__desc {
  font-size: 18px;
  line-height: 1.6;
  color: var(--text-secondary);
  margin: 0 auto 32px;
  max-width: 700px;
}
.lp-hero__cta {
  margin: 0 auto;
}
.lp-hero__trust {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  margin-top: 40px;
  flex-wrap: wrap;
}
.lp-hero__trust-label {
  font-size: 13px;
  color: var(--text-tertiary);
}
.lp-hero__trust-list {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.lp-hero__trust-item {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-secondary);
  text-decoration: none;
  cursor: pointer;
  padding: 6px 14px 6px 10px;
  border: 1px solid var(--border);
  border-radius: var(--radius-full);
  background: var(--background);
  transition: border-color var(--transition-fast), color var(--transition-fast), box-shadow var(--transition-fast);
}
.lp-hero__trust-item:hover {
  color: var(--lp-navy);
  border-color: var(--lp-navy-soft);
  box-shadow: var(--shadow-sm);
}
.lp-hero__trust-ic {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  flex: none;
  border-radius: 4px;
  background: var(--lp-navy-tint);
  color: var(--lp-navy);
  font-size: 10px;
  font-weight: 800;
  overflow: hidden;
}
.lp-hero__trust-ic img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #fff;
}

/* 히어로 제품 앵커 — 매칭 결과 윈도우 목업 */
.lp-hero__product {
  max-width: 760px;
  margin: 52px auto 0;
}
.lp-hero__window {
  border-radius: 16px;
  overflow: hidden;
  background: #fff;
  border: 1px solid var(--lp-navy-line);
  box-shadow: 0 44px 72px -40px rgba(14, 27, 43, 0.5);
  text-align: left;
}
.lp-hero__window-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 18px;
  background: var(--lp-navy);
}
.lp-hero__window-dots { display: inline-flex; gap: 6px; }
.lp-hero__window-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.32);
}
.lp-hero__window-title {
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.92);
}
.lp-hero__window-body { padding: 20px 22px 18px; }
.lp-hero__rtabs { display: flex; gap: 8px; margin-bottom: 16px; }
.lp-hero__rtab {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--text-tertiary);
  padding: 7px 13px;
  border-radius: var(--radius-full);
  border: 1px solid var(--lp-navy-line);
}
.lp-hero__rtab b { font-weight: 800; }
.lp-hero__rtab.is-on {
  color: #fff;
  background: var(--lp-navy);
  border-color: var(--lp-navy);
}
.lp-hero__rlist {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
}
.lp-hero__rrow {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 13px 4px;
  border-top: 1px solid var(--lp-navy-line);
}
.lp-hero__rrow:first-child { border-top: none; }
.lp-hero__rdot {
  flex: none;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--lp-gov);
}
.lp-hero__rmain { flex: 1 1; min-width: 0; display: flex; flex-direction: column; gap: 2px; }
.lp-hero__rname { font-size: 14.5px; font-weight: 700; color: var(--text-primary); }
.lp-hero__rmeta { font-size: 12.5px; color: var(--text-tertiary); }
.lp-hero__rdday {
  flex: none;
  font-size: 12px;
  font-weight: 700;
  color: var(--lp-navy-soft);
  background: var(--lp-navy-tint);
  border-radius: var(--radius-full);
  padding: 5px 11px;
}
.lp-hero__rdday--now { color: var(--lp-gov); background: var(--lp-gov-tint); }
.lp-hero__rfoot {
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid var(--lp-navy-line);
  font-size: 12px;
  color: var(--text-tertiary);
}
@media (max-width: 640px) {
  .lp-hero__product { margin-top: 40px; }
  .lp-hero__window-title { font-size: 12px; }
  /* 매칭 결과 탭(신청 가능/추가 확인/아깝게 탈락) — 좁은 윈도우에서 한 줄 유지 */
  .lp-hero__window-body { padding: 16px 16px 14px; }
  .lp-hero__rtabs { gap: 6px; flex-wrap: nowrap; }
  .lp-hero__rtab { font-size: 11px; padding: 5px 8px; white-space: nowrap; }
}
@media (max-width: 640px) {
  .lp-hero { padding: 64px 20px 48px; }
  .lp-hero__title { font-size: 32px; }
  .lp-hero__desc { font-size: 16px; }
}

/* ── 랜딩 리포지셔닝: 문제 공감 ── */
.lp-pain {
  padding: 56px 24px;
  background: var(--lp-navy-ink);
}
.lp-pain__inner {
  max-width: 720px;
  margin: 0 auto;
  text-align: center;
}
.lp-pain__lead {
  font-size: 26px;
  font-weight: 700;
  line-height: 1.4;
  color: #fff;
  margin: 0 0 12px;
}
.lp-pain__sub {
  font-size: 16px;
  line-height: 1.6;
  color: var(--gray-300, rgba(255, 255, 255, 0.72));
  margin: 0;
}
@media (max-width: 640px) {
  .lp-pain__lead { font-size: 21px; }
}

/* ── 랜딩 리포지셔닝: 공용 섹션 헤더 ── */
.lp-section-head {
  max-width: 720px;
  margin: 0 auto 40px;
  text-align: center;
}
.lp-section-title {
  font-size: 32px;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: var(--text-primary);
  margin: 0 0 14px;
}
.lp-section-sub {
  font-size: 16px;
  line-height: 1.6;
  color: var(--text-secondary);
  margin: 0;
}

/* ── 랜딩 리포지셔닝: 에이전트 라인업 ── */
.lp-agents {
  padding: 80px 24px;
  background: var(--fg-bg-content, var(--surface));
}
.lp-agents__grid {
  max-width: 1140px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 22px;
}
@media (max-width: 980px) {
  .lp-agents__grid { grid-template-columns: 1fr; max-width: 460px; }
}
.lp-agent-card {
  display: flex;
  flex-direction: column;
  background: var(--fg-bg-card, var(--background));
  border: 1px solid var(--border);
  border-radius: var(--radius-2xl);
  padding: 28px;
  box-shadow: var(--shadow-sm);
  transition: box-shadow var(--transition-fast), transform var(--transition-fast);
}
.lp-agent-card:hover {
  box-shadow: var(--shadow-lg);
  transform: translateY(-3px);
}
.lp-agent-card__name {
  font-size: 22px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 12px;
}
.lp-agent-card__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 14px;
}
.lp-agent-card__tag {
  font-size: 12px;
  color: var(--text-secondary);
  background: var(--gray-100, var(--surface));
  border-radius: var(--radius-sm);
  padding: 4px 10px;
}
.lp-agent-card__one {
  font-size: 15px;
  line-height: 1.65;
  color: var(--text-secondary);
  margin: 0 0 16px;
}
.lp-agent-card__moat {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.5;
  color: var(--text-primary);
  margin: 0 0 20px;
}
.lp-agent-card__moat-dot {
  flex: none;
  width: 8px;
  height: 8px;
  margin-top: 6px;
  border-radius: var(--radius-full);
  background: var(--success, var(--fg-class-green));
}
.lp-agent-card__samples {
  margin-bottom: 24px;
}
.lp-agent-card__samples-label {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-tertiary);
  margin: 0 0 10px;
}
.lp-agent-card__samples-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.lp-agent-card__sample {
  font-size: 13px;
  line-height: 1.45;
  color: var(--text-secondary);
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 9px 12px;
}
.lp-agent-card__cta {
  margin-top: auto;
  border: none;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  background: var(--lp-navy);
  border-radius: var(--radius-lg);
  padding: 13px 18px;
  transition: background var(--transition-fast);
}
.lp-agent-card__cta:hover {
  background: var(--lp-navy-ink);
}
@media (max-width: 760px) {
  .lp-agents { padding: 56px 20px; }
  .lp-agents__grid { grid-template-columns: 1fr; }
}

/* ── 랜딩 리포지셔닝: 작동 방식 ── */
.lp-how {
  padding: 80px 24px;
  background: var(--background);
}
.lp-how__steps {
  max-width: 960px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}
.lp-how__step {
  background: var(--fg-bg-card, var(--surface));
  border: 1px solid var(--border);
  border-radius: var(--radius-xl);
  padding: 28px 24px;
}
.lp-how__step-no {
  display: inline-block;
  font-size: 14px;
  font-weight: 700;
  color: var(--lp-navy);
  margin-bottom: 14px;
}
.lp-how__step-title {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 10px;
}
.lp-how__step-desc {
  font-size: 14px;
  line-height: 1.65;
  color: var(--text-secondary);
  margin: 0;
}
@media (max-width: 760px) {
  .lp-how { padding: 56px 20px; }
  .lp-how__steps { grid-template-columns: 1fr; }
}

/* ── 랜딩 리포지셔닝: 해자 ── */
.lp-moat {
  padding: 80px 24px;
  background: var(--fg-bg-content, var(--surface));
}
.lp-moat__grid {
  max-width: 960px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}
.lp-moat__item {
  background: var(--background);
  border: 1px solid var(--border);
  border-left: 3px solid var(--lp-navy);
  border-radius: var(--radius-lg);
  padding: 24px;
}
.lp-moat__item-title {
  font-size: 17px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 10px;
}
.lp-moat__item-desc {
  font-size: 14px;
  line-height: 1.65;
  color: var(--text-secondary);
  margin: 0;
}
@media (max-width: 760px) {
  .lp-moat { padding: 56px 20px; }
  .lp-moat__grid { grid-template-columns: 1fr; }
}

/* ── 랜딩 리포지셔닝: 최종 CTA ── */
.lp-cta {
  padding: 88px 24px;
  background: var(--lp-navy-ink);
}
.lp-cta__inner {
  max-width: 640px;
  margin: 0 auto;
  text-align: center;
}
.lp-cta__title {
  font-size: 32px;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: #fff;
  margin: 0 0 14px;
}
.lp-cta__desc {
  font-size: 16px;
  line-height: 1.6;
  color: var(--gray-300, rgba(255, 255, 255, 0.72));
  margin: 0 0 28px;
}
.lp-cta__logo {
  height: 36px;
  width: auto;
  object-fit: contain;
  margin: 0 auto 28px;
  display: block;
}
@media (max-width: 640px) {
  .lp-cta { padding: 64px 20px; }
  .lp-cta__title { font-size: 24px; }
}

/* ── 마지막 화면: CTA + 푸터 통합 (다크 마무리) ──
   데스크탑(풀페이지)에서는 CTA 콘텐츠를 중앙에, 푸터를 화면 하단에 고정.
   푸터는 다크 네이비 배경에 맞춰 밝게 반전한다. */
@media (min-width: 761px) {
  .lp-cta { position: relative; }
  .lp-cta > .landing-footer {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
  }
}
.lp-cta > .landing-footer {
  padding: 22px 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}
.lp-cta .landing-footer__link { color: rgba(255, 255, 255, 0.72); }
.lp-cta .landing-footer__link:hover { color: #fff; text-decoration: underline; }
.lp-cta .landing-footer__copyright { color: rgba(255, 255, 255, 0.5); }

/* ════════════════════════════════════════════════════════
   랜딩 리포지셔닝 v2 — 실서비스 확장 (모델·비교 / 3 에이전트 / 플랜 / FAQ)
   다크 네이비 에디토리얼 톤. 풀블리드 밴드 + 세리프 숫자 액센트.
   ════════════════════════════════════════════════════════ */

/* 홈 전용: 공유 .landing__main 의 gap/padding/center 리셋 → 섹션이 풀폭 밴드를 직접 제어 */
.lp-main {
  gap: 0;
  padding: 0;
  align-items: stretch;
}

/* 공용 버튼 시스템 */
.lp-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-family: var(--font-sans);
  font-weight: 600;
  font-size: 15px;
  line-height: 1;
  border: 1px solid transparent;
  border-radius: 10px;
  padding: 12px 20px;
  cursor: pointer;
  text-decoration: none;
  transition: background var(--transition-fast), border-color var(--transition-fast), color var(--transition-fast), transform var(--transition-fast);
}
.lp-btn:active { transform: translateY(1px); }
.lp-btn--lg { padding: 15px 28px; font-size: 16px; }
.lp-btn--primary { background: var(--lp-navy); color: #fff; }
.lp-btn--primary:hover { background: var(--lp-navy-ink); }
.lp-btn--outline { background: #fff; color: var(--lp-navy); border-color: var(--lp-navy); }
.lp-btn--outline:hover { background: var(--lp-navy-tint); }
.lp-btn--ghost { background: transparent; color: var(--lp-navy); border-color: var(--lp-navy-line); }
.lp-btn--ghost:hover { background: var(--lp-navy-tint); border-color: var(--lp-navy-soft); }
.lp-btn--invert { background: #fff; color: var(--lp-navy); }
.lp-btn--invert:hover { background: var(--lp-navy-tint); }

/* 공용 eyebrow */
.lp-eyebrow {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--lp-navy-soft);
  margin: 0 0 14px;
}

/* 히어로 액션 행 */
.lp-hero__actions {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
}

/* ── 모델 & 비교 ── */
.lp-models {
  padding: 88px 24px;
  background: var(--background);
}
.lp-model-wall {
  list-style: none;
  margin: 0 auto 44px;
  padding: 0;
  max-width: 920px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
}
.lp-model-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 16px 9px 12px;
  background: #fff;
  border: 1px solid var(--lp-navy-line);
  border-radius: var(--radius-full);
  font-size: 14px;
  font-weight: 600;
  color: var(--lp-navy);
  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);
}
.lp-model-chip:hover {
  border-color: var(--lp-navy-soft);
  box-shadow: var(--shadow-sm);
}
.lp-model-chip__logo {
  display: inline-flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
}
.lp-model-chip--more {
  color: var(--lp-navy-soft);
  background: var(--lp-navy-tint);
  border-color: transparent;
}

/* 비교 미리보기 카드 */
.lp-compare {
  max-width: 920px;
  margin: 0 auto;
  background: #fff;
  border: 1px solid var(--lp-navy-line);
  border-radius: var(--radius-2xl);
  box-shadow: 0 24px 48px -32px rgba(14, 27, 43, 0.4);
  overflow: hidden;
}
.lp-compare__ask {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 18px 24px;
  background: var(--lp-navy);
  color: #fff;
}
.lp-compare__ask-label {
  flex: none;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: var(--radius-full);
  padding: 4px 10px;
}
.lp-compare__ask-text { font-size: 15px; font-weight: 500; }
.lp-compare__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}
.lp-compare__col {
  padding: 22px 22px 26px;
  border-left: 1px solid var(--lp-navy-line);
}
.lp-compare__col:first-child { border-left: none; }
.lp-compare__col-head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}
.lp-compare__col-name { font-size: 14px; font-weight: 700; color: var(--lp-navy); }
.lp-compare__col-text {
  margin: 0;
  font-size: 13.5px;
  line-height: 1.62;
  color: var(--text-secondary);
}

/* ── 작동방식: 번호를 에디토리얼 세리프로 ── */
.lp-how__step-no {
  display: block;
  font-family: var(--lp-serif);
  font-size: 40px;
  font-weight: 500;
  line-height: 1;
  color: var(--lp-navy);
  margin-bottom: 16px;
}

/* ── 에이전트: 공급기업 카드 강조 ── */
.lp-agent-card { position: relative; }
.lp-agent-card--supplier {
  border-color: var(--lp-gov);
  box-shadow: 0 0 0 1px var(--lp-gov), var(--shadow-sm);
}
.lp-agent-card__ribbon {
  position: absolute;
  top: 16px;
  right: 16px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #fff;
  background: var(--lp-gov);
  border-radius: var(--radius-full);
  padding: 5px 11px;
}
/* 카드 헤더 로고 — 텍스트 배지 대체 (supplier=모두의 창업 / 그 외=GrowFit) */
.lp-agent-card__logo {
  align-self: flex-start;
  display: block;
  width: auto;
  height: 28px;
  margin-bottom: 16px;
}
/* GrowFit 브랜드 로고는 여러 카드에 반복되므로 한 단계 절제 */
.lp-agent-card__logo--brand {
  height: 22px;
}

/* ── 플랜 · 가격 ── */
.lp-pricing {
  padding: 88px 24px;
  background: var(--background);
}
.lp-pricing__grid {
  max-width: 1040px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 22px;
  align-items: start;
}
.lp-plan {
  position: relative;
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid var(--lp-navy-line);
  border-radius: var(--radius-2xl);
  padding: 30px 26px;
}
.lp-plan--featured {
  border: 1.5px solid var(--lp-navy);
  box-shadow: 0 28px 56px -34px rgba(14, 27, 43, 0.45);
}
.lp-plan__flag {
  position: absolute;
  top: -12px;
  left: 26px;
  font-size: 12px;
  font-weight: 700;
  color: #fff;
  background: var(--lp-navy);
  border-radius: var(--radius-full);
  padding: 5px 13px;
}
.lp-plan__name { font-size: 18px; font-weight: 800; color: var(--lp-navy); margin: 0 0 4px; }
.lp-plan__tagline { font-size: 13px; color: var(--text-tertiary); margin: 0 0 20px; }
.lp-plan__price {
  display: flex;
  align-items: baseline;
  gap: 6px;
  margin: 0 0 6px;
}
.lp-plan__price-num {
  font-family: var(--lp-serif);
  font-size: 40px;
  font-weight: 600;
  line-height: 1;
  color: var(--text-primary);
}
.lp-plan__price-unit { font-size: 14px; color: var(--text-secondary); }
.lp-plan__tokens { font-size: 13px; font-weight: 600; color: var(--lp-navy-soft); margin: 0 0 22px; }
.lp-plan__cta { width: 100%; margin-bottom: 24px; }
.lp-plan__features { list-style: none; margin: 0; padding: 20px 0 0; border-top: 1px solid var(--lp-navy-line); display: flex; flex-direction: column; gap: 12px; }
.lp-plan__feature { display: flex; align-items: flex-start; gap: 9px; font-size: 14px; line-height: 1.45; color: var(--text-secondary); }
.lp-plan__check { flex: none; margin-top: 1px; color: var(--lp-navy); }
.lp-pricing__note { max-width: 1040px; margin: 26px auto 0; text-align: center; font-size: 12.5px; color: var(--text-tertiary); }

/* ── FAQ ── */
.lp-faq {
  padding: 88px 24px;
  background: var(--fg-bg-content, var(--surface));
}
.lp-faq__list { max-width: 920px; margin: 0 auto; }
.lp-faq__item { border-bottom: 1px solid var(--lp-navy-line); }
.lp-faq__item:first-child { border-top: 1px solid var(--lp-navy-line); }
.lp-faq__q {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 22px 4px;
  font-size: 16px;
  font-weight: 700;
  color: var(--text-primary);
  cursor: pointer;
  list-style: none;
}
.lp-faq__q::-webkit-details-marker { display: none; }
.lp-faq__icon { flex: none; color: var(--lp-navy-soft); transition: transform var(--transition-fast); }
.lp-faq__item[open] .lp-faq__icon { transform: rotate(180deg); }
.lp-faq__a {
  margin: 0;
  padding: 0 4px 24px;
  font-size: 14.5px;
  line-height: 1.7;
  color: var(--text-secondary);
}

/* ── 반응형 ── */
@media (max-width: 860px) {
  .lp-pricing__grid { grid-template-columns: 1fr; max-width: 460px; }
  .lp-plan--featured { order: -1; }
}
@media (max-width: 760px) {
  .lp-models, .lp-pricing, .lp-faq { padding: 60px 20px; }
  .lp-compare__grid { grid-template-columns: 1fr; }
  .lp-compare__col { border-left: none; border-top: 1px solid var(--lp-navy-line); }
  .lp-compare__col:first-child { border-top: none; }
  .lp-compare__ask { flex-direction: column; align-items: flex-start; gap: 8px; }
}

/* ── 좁은 화면(≤480) 미세 튜닝 — 타이틀 과대 방지 + CTA 풀폭 스택 ── */
@media (max-width: 480px) {
  .lp-hero__title { font-size: 28px; }
  .lp-section-title { font-size: 26px; }
  .lp-cta__title { font-size: 22px; }
  .lp-hero__actions { flex-direction: column; align-items: stretch; }
  .lp-hero__actions .lp-btn { width: 100%; }
}

/* ── 스크롤 리빌 ──
   useScrollReveal 훅이 뷰포트 진입 시 .is-revealed를 부착한다.
   순차 등장(stagger)은 컴포넌트에서 inline transition-delay로 제어. */
.lp-reveal {
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.6s ease-out, transform 0.6s ease-out;
}
.lp-reveal.is-revealed {
  opacity: 1;
  transform: none;
}
/* 접근성: 모션 비선호 사용자는 등장 애니메이션 없이 즉시 표시 */
@media (prefers-reduced-motion: reduce) {
  .lp-reveal {
    opacity: 1 !important;
    transform: none !important;
    transition: none !important;
  }
}

/* ── 풀페이지 스크롤 (데스크탑 전용) ──
   각 섹션 = 1화면. 휠/키 입력은 useFullpageScroll 훅이 가로채
   한 번에 한 섹션씩 부드럽게(easing) 이동시킨다.
   CSS scroll-snap은 JS 애니메이션과 충돌하므로 사용하지 않는다.
   모바일(≤760) / prefers-reduced-motion 에서는 훅이 비활성 → 일반 스크롤. */
@media (min-width: 761px) {
  .landing__main.lp-main {
    padding: 0;
    align-items: stretch;
  }
  .lp-main > section {
    /* sticky 헤더(64px)를 뺀 실제 가시영역에 맞춰야 콘텐츠가 헤더에 가리지 않음 */
    min-height: calc(100vh - 64px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
  }
  /* flex 컨테이너 안에서는 margin:auto 자식이 콘텐츠 폭으로 줄어든다.
     직속 자식을 풀폭으로 두어 각자의 max-width+margin auto(중앙 정렬)가 정상 동작하게 한다. */
  .lp-main > section > * { width: 100%; }

  /* 풀페이지 1화면에 맞춰 여백을 컴팩트화 (히어로·에이전트 잘림 방지) */
  .lp-hero { padding-top: 24px; padding-bottom: 20px; }
  .lp-hero__eyebrow { margin-bottom: 10px; }
  .lp-hero__title { margin-bottom: 14px; }
  .lp-hero__desc { margin-bottom: 18px; }
  .lp-hero__product { margin-top: 20px; }
  .lp-hero__trust { margin-top: 16px; }
  .lp-hero__rrow { padding-top: 10px; padding-bottom: 10px; }
  .lp-agents { padding-top: 40px; padding-bottom: 40px; }
}

/* ── 섹션 네비 (풀페이지 우측 도트) ──
   데스크탑에서만 표시. 현재 섹션 강조 + hover/포커스 시 이름 라벨. */
.lp-secnav {
  position: fixed;
  top: 50%;
  right: 22px;
  transform: translateY(-50%);
  z-index: 50;
  display: none;
}
@media (min-width: 761px) {
  .lp-secnav { display: block; }
}
.lp-secnav__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 16px;
}
.lp-secnav__dot {
  position: relative;
  display: flex;
  align-items: center;
  padding: 5px;
  background: none;
  border: none;
  cursor: pointer;
}
.lp-secnav__dot::after {
  content: '';
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--lp-navy-line);
  transition: background var(--transition-fast), transform var(--transition-fast);
}
.lp-secnav__dot:hover::after { background: var(--lp-navy-soft); }
.lp-secnav__dot.is-active::after {
  background: var(--lp-navy);
  transform: scale(1.45);
}
.lp-secnav__label {
  position: absolute;
  right: calc(100% + 2px);
  white-space: nowrap;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  background: var(--lp-navy);
  padding: 4px 10px;
  border-radius: var(--radius-full);
  opacity: 0;
  transform: translateX(4px);
  pointer-events: none;
  transition: opacity var(--transition-fast), transform var(--transition-fast);
}
.lp-secnav__dot:hover .lp-secnav__label,
.lp-secnav__dot:focus-visible .lp-secnav__label {
  opacity: 1;
  transform: translateX(0);
}
/* 다크 배경 섹션 위에서는 도트·라벨을 밝게 반전 */
.lp-secnav.is-on-dark .lp-secnav__dot::after { background: rgba(255, 255, 255, 0.45); }
.lp-secnav.is-on-dark .lp-secnav__dot:hover::after { background: rgba(255, 255, 255, 0.8); }
.lp-secnav.is-on-dark .lp-secnav__dot.is-active::after { background: #fff; }
.lp-secnav.is-on-dark .lp-secnav__label { background: #fff; color: var(--lp-navy); }
@media (prefers-reduced-motion: reduce) {
  .lp-secnav__label { transition: none; }
}
`, "",{"version":3,"sources":["webpack://./src/css/Landing.css"],"names":[],"mappings":"AAAA;;;;qEAIqE;;AAErE,kCAAkC;AAClC;IACI,iBAAiB;IACjB,mBAAmB;IACnB,2BAA2B;IAC3B,6BAA6B;IAC7B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,SAAO;IACP,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,uBAAuB;IACvB,SAAS;AACb;;AAEA,iCAAiC;AACjC;IACI,gBAAgB;IAChB,MAAM;IACN,YAAY;IACZ,mBAAmB;IACnB,oCAAoC;IACpC,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,2BAA2B;IAC3B,eAAe;IACf,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;IAC/B,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,eAAe;IACf,6CAA6C;AACjD;;AAEA;IACI,qCAAqC;AACzC;;AAEA,sCAAsC;AACtC;;;IAGI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,2BAA2B;IAC3B,eAAe;IACf,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA,qDAAqD;AACrD;IACI,kBAAkB,kBAAkB,EAAE;IACtC,4BAA4B,YAAY,EAAE;;IAE1C;QACI,oBAAoB;IACxB;;IAEA,2BAA2B;IAC3B;QACI,cAAc;QACd,eAAe;QACf,QAAQ;QACR,YAAY;QACZ,YAAY;QACZ,iCAAiC;QACjC,UAAU;QACV,kBAAkB;QAClB,qDAAqD;QACrD,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,mBAAmB;IACvB;;IAEA,oBAAoB;IACpB;QACI,eAAe;QACf,MAAM;QACN,QAAQ;QACR,YAAY;QACZ,sBAAsB;QACtB,oBAAoB;QACpB,QAAQ;QACR,uBAAuB;QACvB,YAAY;QACZ,uBAAuB;QACvB,sBAAsB;QACtB,mBAAmB;QACnB,4BAA4B;QAC5B,2BAA2B;QAC3B,wDAAwD;QACxD,gBAAgB;IACpB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,oBAAoB;QACpB,kBAAkB;QAClB,SAAS;QACT,WAAW;QACX,gBAAgB;QAChB,YAAY;QACZ,YAAY;QACZ,0BAA0B;QAC1B,eAAe;QACf,cAAc;QACd,+BAA+B;IACnC;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,2BAA2B;QAC3B,gBAAgB;QAChB,WAAW;QACX,gBAAgB;QAChB,kBAAkB;QAClB,eAAe;QACf,+BAA+B;IACnC;;IAEA,0BAA0B;IAC1B;QACI,YAAY;QACZ,WAAW;QACX,gBAAgB;QAChB,aAAa;QACb,eAAe;QACf,kBAAkB;IACtB;AACJ;;AAEA,iCAAiC;AACjC;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,2BAA2B;IAC3B,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,2BAA2B;AAC/B;;AAEA,qCAAqC;AACrC;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,SAAS;AACb;;AAEA,0CAA0C;AAC1C;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,yBAAyB;IACzB,6BAA6B;IAC7B,gCAAgC;IAChC,kBAAkB;IAClB,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,eAAe;IACf,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,6BAA6B;IAC7B,gCAAgC;IAChC,mBAAmB;IACnB,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;;yDAEyD;;AAEzD;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gDAAgD;IAChD,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,gCAAgC;IAChC,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,eAAe;IACf,4CAA4C;IAC5C,cAAc;AAClB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;mDACmD;AACnD;IACI,YAAY;IACZ,6BAA6B;IAC7B,8BAA8B;IAC9B,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,mDAAmD;IACnD,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,kHAAkH;IAClH,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB;kCAC8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,6BAA6B;IAC7B,YAAY;IACZ,4CAA4C;IAC5C,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA,sCAAsC;AACtC;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;IAC7B,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,iBAAiB;IACjB,gEAAgE;IAChE,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA,oCAAoC;AACpC;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,wDAAwD;IACxD,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,aAAa;IACb,6BAA6B;IAC7B,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,gBAAgB;IAChB,kBAAkB;IAClB,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,SAAO;IACP,kBAAkB;IAClB,6DAA6D;IAC7D,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;AAClB;;AAEA,uCAAuC;AACvC;IACI,WAAW;IACX,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;;;6BAG6B;AAC7B;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,UAAU;IACV,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,eAAe;IACf,4CAA4C;IAC5C,gBAAgB;IAChB,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;IACI,iCAAiC;AACrC;;AAEA,4BAA4B;AAC5B;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA,iCAAiC;AACjC;IACI,WAAW;IACX,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,+DAA+D;IAC/D,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;IAClB,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,2BAA2B;AAC/B;;AAEA,WAAW;AACX;IACI,WAAW;IACX,iBAAiB;IACjB,mEAAmE;IACnE,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;;yDAEyD;AACzD;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;IAClB,SAAS;AACb;;AAEA,mDAAmD;AACnD;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,6BAA6B;IAC7B,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,0BAA0B;IAC1B,SAAS;AACb;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,gCAAgC;IAChC,mBAAmB;IACnB,0BAA0B;IAC1B,YAAY;AAChB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,0CAA0C;IAC1C,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,uCAAuC;IACvC,mBAAmB;IACnB,eAAe;IACf,6CAA6C;IAC7C,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,SAAS;IACT,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;AAChC;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,0BAA0B;IAC1B,SAAS;AACb;;AAEA,iCAAiC;AACjC;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,QAAQ;IACR,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,0BAA0B;IAC1B,2EAA2E;AAC/E;;AAEA;IACI,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA,qCAAqC;AACrC;IACI,gCAAgC;IAChC;;QAEI,kBAAkB;QAClB,mBAAmB;IACvB;IACA,oDAAoD;IACpD;QACI,sBAAsB;QACtB,oBAAoB;QACpB,QAAQ;QACR,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,mBAAmB;QACnB,mBAAmB;QACnB,2BAA2B;QAC3B,gBAAgB;QAChB,QAAQ;IACZ;IACA,2BAA2B;IAC3B;QACI,WAAW;QACX,mBAAmB;QACnB,mBAAmB;QACnB,sBAAsB;QACtB,SAAS;IACb;IACA;QACI,gBAAgB;IACpB;IACA,WAAW;IACX;QACI,WAAW;IACf;AACJ;;AAEA;;;4CAG4C;AAC5C;IACI,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA,mEAAmE;AACnE;;;;;;;;;;;IAWI,SAAS;IACT,UAAU;AACd;;AAEA;2CAC2C;AAC3C;IACI,iBAAiB;AACrB;;AAEA,iCAAiC;AACjC;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA,wDAAwD;AACxD;;IAEI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,qBAAqB;AACrB;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,aAAa;IACb,0BAA0B;AAC9B;;AAEA,kBAAkB;AAClB;IACI,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,2DAA2D;IAC3D,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,qBAAqB;IACrB,2DAA2D;IAC3D,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA,YAAY;AACZ;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,0DAA0D;AAC1D;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA,sDAAsD;AACtD;IACI,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;;IAGI,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,QAAQ;AACR;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,gCAAgC;IAChC,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,4BAA4B;IAC5B,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;;yDAEyD;AACzD;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;IAC/B,YAAY;IACZ,YAAY;IACZ,qBAAqB;IACrB,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,6CAA6C;AACjD;;AAEA;IACI,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,SAAS;IACT,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,4BAA4B;IAC5B,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,6CAA6C;AACjD;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,uBAAuB;IACvB,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;yDAEyD;AACzD;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,mBAAmB;IACnB,gCAAgC;IAChC,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,6CAA6C;IAC7C,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,uCAAuC;IACvC,mBAAmB;IACnB,eAAe;IACf,6CAA6C;IAC7C,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,0BAA0B;IAC1B,SAAS;IACT,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iEAAiE;IACjE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,MAAM;IACN,6BAA6B;IAC7B,eAAe;IACf,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;yDAEyD;AACzD;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,0BAA0B;IAC1B,gCAAgC;IAChC,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,+BAA+B;IAC/B,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,eAAe;IACf,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,0BAA0B;IAC1B,gCAAgC;IAChC,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,6CAA6C;IAC7C,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,SAAO;IACP,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,cAAc;IACd,4CAA4C;AAChD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,0BAA0B;IAC1B,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,2BAA2B;IAC3B,SAAS;AACb;;AAEA,sBAAsB;AACtB;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,iCAAiC;IACjC,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,4CAA4C;AAChD;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,gCAAgC;IAChC,6BAA6B;IAC7B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,+BAA+B;IAC/B,eAAe;IACf,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2EAA2E;AAC/E;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,4BAA4B;AAChC;;AAEA;;;;;yDAKyD;;AAEzD,yBAAyB;AACzB;IACI;QACI,qCAAqC;QACrC,SAAS;IACb;AACJ;;AAEA;IACI,uCAAuC;IACvC;QACI,SAAS;IACb;;IAEA,sCAAsC;IACtC;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,SAAS;IACb;;IAEA,uCAAuC;IACvC;QACI,cAAc;IAClB;;IAEA;QACI,YAAY;QACZ,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA,eAAe;IACf;QACI,SAAS;IACb;;IAEA,+CAA+C;IAC/C;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA,WAAW;IACX;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA,qCAAqC;IACrC;QACI,WAAW;QACX,YAAY;QACZ,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;;+BAE2B;IAC3B;QACI,sBAAsB;QACtB,YAAY;QACZ,MAAM;IACV;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,UAAU;QACV,WAAW;QACX,aAAa;IACjB;;IAEA;mCAC+B;IAC/B;QACI,SAAS;QACT,YAAY;QACZ,eAAe;QACf,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;;uDAEuD;AACvD;EACE,kBAAkB,SAAS,YAAY;EACvC,sBAAsB,KAAK,6BAA6B;EACxD,uBAAuB,IAAI,WAAW;EACtC,uBAAuB,IAAI,mBAAmB;EAC9C,qCAAqC,GAAG,SAAS;EACjD,iBAAiB,UAAU,eAAe;EAC1C,sBAAsB;EACtB,2DAA2D,GAAG,aAAa;AAC7E;;AAEA,wBAAwB;AACxB;EACE,uBAAuB;EACvB,gDAAgD;AAClD;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;EACrB,eAAe;EACf,0BAA0B;EAC1B,+BAA+B;EAC/B,iCAAiC;EACjC,6BAA6B;EAC7B,gHAAgH;AAClH;AACA;EACE,qBAAqB;EACrB,iCAAiC;EACjC,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,+BAA+B;EAC/B,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;EACrC,mDAAmD;EACnD,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;AAC5B;AACA,wBAAwB,oBAAoB,EAAE,QAAQ,EAAE;AACxD;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;AACvC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;AACA,wBAAwB,uBAAuB,EAAE;AACjD,kBAAkB,aAAa,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AAChE;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;EACjB,iCAAiC;EACjC,qCAAqC;AACvC;AACA,mBAAmB,gBAAgB,EAAE;AACrC;EACE,WAAW;EACX,0BAA0B;EAC1B,4BAA4B;AAC9B;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,yCAAyC;AAC3C;AACA,6BAA6B,gBAAgB,EAAE;AAC/C;EACE,UAAU;EACV,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;AACA,kBAAkB,SAAO,EAAE,YAAY,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC1F,kBAAkB,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AACnF,kBAAkB,iBAAiB,EAAE,2BAA2B,EAAE;AAClE;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,+BAA+B;EAC/B,iCAAiC;EACjC,iBAAiB;AACnB;AACA,uBAAuB,oBAAoB,EAAE,8BAA8B,EAAE;AAC7E;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;EACzC,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,oBAAoB,gBAAgB,EAAE;EACtC,yBAAyB,eAAe,EAAE;EAC1C,kDAAkD;EAClD,wBAAwB,uBAAuB,EAAE;EACjD,kBAAkB,QAAQ,EAAE,iBAAiB,EAAE;EAC/C,iBAAiB,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AAC3E;AACA;EACE,WAAW,uBAAuB,EAAE;EACpC,kBAAkB,eAAe,EAAE;EACnC,iBAAiB,eAAe,EAAE;AACpC;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iDAAiD;EACjD,SAAS;AACX;AACA;EACE,iBAAiB,eAAe,EAAE;AACpC;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,gDAAgD;AAClD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;AACA;EACE,mBAAmB,0BAA0B,EAAE,gBAAgB,EAAE;AACnE;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gDAAgD;EAChD,+BAA+B;EAC/B,gCAAgC;EAChC,aAAa;EACb,4BAA4B;EAC5B,+EAA+E;AACjF;AACA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,4BAA4B;EAC5B,2CAA2C;EAC3C,+BAA+B;EAC/B,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,UAAU;EACV,WAAW;EACX,eAAe;EACf,iCAAiC;EACjC,iDAAiD;AACnD;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;EAClB,6CAA6C;AAC/C;AACA;EACE,8BAA8B;AAChC;AACA;EACE,aAAa,kBAAkB,EAAE;EACjC,mBAAmB,0BAA0B,EAAE;AACjD;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;AACA;EACE,6CAA6C;EAC7C,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,SAAS;AACX;AACA;EACE,UAAU,kBAAkB,EAAE;EAC9B,iBAAiB,0BAA0B,EAAE;AAC/C;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,gDAAgD;AAClD;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;AACA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,SAAS;AACX;AACA;EACE,WAAW,kBAAkB,EAAE;EAC/B,iBAAiB,0BAA0B,EAAE;AAC/C;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iDAAiD;EACjD,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,UAAU,kBAAkB,EAAE;EAC9B,iBAAiB,eAAe,EAAE;AACpC;;AAEA;;+BAE+B;AAC/B;EACE,UAAU,kBAAkB,EAAE;EAC9B;IACE,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;EACX;AACF;AACA;EACE,kBAAkB;EAClB,8CAA8C;AAChD;AACA,gCAAgC,gCAAgC,EAAE;AAClE,sCAAsC,WAAW,EAAE,0BAA0B,EAAE;AAC/E,qCAAqC,+BAA+B,EAAE;;AAEtE;;;6DAG6D;;AAE7D,uEAAuE;AACvE;EACE,MAAM;EACN,UAAU;EACV,oBAAoB;AACtB;;AAEA,cAAc;AACd;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,kJAAkJ;AACpJ;AACA,iBAAiB,0BAA0B,EAAE;AAC7C,cAAc,kBAAkB,EAAE,eAAe,EAAE;AACnD,mBAAmB,0BAA0B,EAAE,WAAW,EAAE;AAC5D,yBAAyB,8BAA8B,EAAE;AACzD,mBAAmB,gBAAgB,EAAE,qBAAqB,EAAE,4BAA4B,EAAE;AAC1F,yBAAyB,+BAA+B,EAAE;AAC1D,iBAAiB,uBAAuB,EAAE,qBAAqB,EAAE,iCAAiC,EAAE;AACpG,uBAAuB,+BAA+B,EAAE,iCAAiC,EAAE;AAC3F,kBAAkB,gBAAgB,EAAE,qBAAqB,EAAE;AAC3D,wBAAwB,+BAA+B,EAAE;;AAEzD,eAAe;AACf;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,gBAAgB;EAChB,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kFAAkF;AACpF;AACA;EACE,iCAAiC;EACjC,4BAA4B;AAC9B;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,qCAAqC;EACrC,gCAAgC;EAChC,mDAAmD;EACnD,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,WAAW;AACb;AACA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,+BAA+B;EAC/B,2CAA2C;EAC3C,iCAAiC;EACjC,iBAAiB;AACnB;AACA,wBAAwB,eAAe,EAAE,gBAAgB,EAAE;AAC3D;EACE,aAAa;EACb,qCAAqC;AACvC;AACA;EACE,uBAAuB;EACvB,0CAA0C;AAC5C;AACA,+BAA+B,iBAAiB,EAAE;AAClD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;AACA,wBAAwB,eAAe,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;AAClF;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA,+BAA+B;AAC/B;EACE,cAAc;EACd,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B,iBAAiB,kBAAkB,EAAE;AACrC;EACE,2BAA2B;EAC3B,qDAAqD;AACvD;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,yBAAyB;EACzB,iCAAiC;EACjC,iBAAiB;AACnB;AACA,yDAAyD;AACzD;EACE,sBAAsB;EACtB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA,yCAAyC;AACzC;EACE,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,qCAAqC;EACrC,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,kCAAkC;EAClC,oDAAoD;AACtD;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,0BAA0B;EAC1B,iCAAiC;EACjC,iBAAiB;AACnB;AACA,iBAAiB,eAAe,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,eAAe,EAAE;AAC5F,oBAAoB,eAAe,EAAE,2BAA2B,EAAE,gBAAgB,EAAE;AACpF;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;AACA,uBAAuB,eAAe,EAAE,4BAA4B,EAAE;AACtE,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,gBAAgB,EAAE;AACpG,gBAAgB,WAAW,EAAE,mBAAmB,EAAE;AAClD,qBAAqB,gBAAgB,EAAE,SAAS,EAAE,iBAAiB,EAAE,yCAAyC,EAAE,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AAClK,oBAAoB,aAAa,EAAE,uBAAuB,EAAE,QAAQ,EAAE,eAAe,EAAE,iBAAiB,EAAE,4BAA4B,EAAE;AACxI,kBAAkB,UAAU,EAAE,eAAe,EAAE,qBAAqB,EAAE;AACtE,oBAAoB,iBAAiB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,2BAA2B,EAAE;;AAEhI,cAAc;AACd;EACE,kBAAkB;EAClB,gDAAgD;AAClD;AACA,gBAAgB,gBAAgB,EAAE,cAAc,EAAE;AAClD,gBAAgB,4CAA4C,EAAE;AAC9D,4BAA4B,yCAAyC,EAAE;AACvE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;AACA,qCAAqC,aAAa,EAAE;AACpD,gBAAgB,UAAU,EAAE,0BAA0B,EAAE,4CAA4C,EAAE;AACtG,oCAAoC,yBAAyB,EAAE;AAC/D;EACE,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,cAAc;AACd;EACE,oBAAoB,0BAA0B,EAAE,gBAAgB,EAAE;EAClE,qBAAqB,SAAS,EAAE;AAClC;AACA;EACE,mCAAmC,kBAAkB,EAAE;EACvD,oBAAoB,0BAA0B,EAAE;EAChD,mBAAmB,iBAAiB,EAAE,yCAAyC,EAAE;EACjF,+BAA+B,gBAAgB,EAAE;EACjD,mBAAmB,sBAAsB,EAAE,uBAAuB,EAAE,QAAQ,EAAE;AAChF;;AAEA,oDAAoD;AACpD;EACE,kBAAkB,eAAe,EAAE;EACnC,oBAAoB,eAAe,EAAE;EACrC,iBAAiB,eAAe,EAAE;EAClC,oBAAoB,sBAAsB,EAAE,oBAAoB,EAAE;EAClE,4BAA4B,WAAW,EAAE;AAC3C;;AAEA;;wDAEwD;AACxD;EACE,UAAU;EACV,2BAA2B;EAC3B,0DAA0D;AAC5D;AACA;EACE,UAAU;EACV,eAAe;AACjB;AACA,uCAAuC;AACvC;EACE;IACE,qBAAqB;IACrB,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF;;AAEA;;;;4DAI4D;AAC5D;EACE;IACE,UAAU;IACV,oBAAoB;EACtB;EACA;IACE,oDAAoD;IACpD,8BAA8B;IAC9B,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;EACxB;EACA;mEACiE;EACjE,yBAAyB,WAAW,EAAE;;EAEtC,2CAA2C;EAC3C,WAAW,iBAAiB,EAAE,oBAAoB,EAAE;EACpD,oBAAoB,mBAAmB,EAAE;EACzC,kBAAkB,mBAAmB,EAAE;EACvC,iBAAiB,mBAAmB,EAAE;EACtC,oBAAoB,gBAAgB,EAAE;EACtC,kBAAkB,gBAAgB,EAAE;EACpC,iBAAiB,iBAAiB,EAAE,oBAAoB,EAAE;EAC1D,aAAa,iBAAiB,EAAE,oBAAoB,EAAE;AACxD;;AAEA;8CAC8C;AAC9C;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,WAAW;EACX,aAAa;AACf;AACA;EACE,aAAa,cAAc,EAAE;AAC/B;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,+EAA+E;AACjF;AACA,+BAA+B,+BAA+B,EAAE;AAChE;EACE,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,0BAA0B;EAC1B,iBAAiB;EACjB,iCAAiC;EACjC,UAAU;EACV,0BAA0B;EAC1B,oBAAoB;EACpB,4EAA4E;AAC9E;AACA;;EAEE,UAAU;EACV,wBAAwB;AAC1B;AACA,+BAA+B;AAC/B,+CAA+C,qCAAqC,EAAE;AACtF,qDAAqD,oCAAoC,EAAE;AAC3F,yDAAyD,gBAAgB,EAAE;AAC3E,0CAA0C,gBAAgB,EAAE,qBAAqB,EAAE;AACnF;EACE,oBAAoB,gBAAgB,EAAE;AACxC","sourcesContent":["/* ================================================================\n * Landing — 비로그인 진입 페이지 (홈/공지/요금제/강의/고객센터)\n * 디자인: 피그마 GrowFit 2026-04 시안\n * 토큰: variables.css 의 --fg-* 사용\n * ================================================================ */\n\n/* ---------- 공통 레이아웃 ---------- */\n.landing {\n    min-height: 100vh;\n    background: #ffffff;\n    color: var(--fg-text-basic);\n    font-family: var(--font-sans);\n    display: flex;\n    flex-direction: column;\n}\n\n.landing__main {\n    flex: 1;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 40px 24px 80px;\n    gap: 160px;\n}\n\n.landing__main--narrow {\n    padding: 40px 24px 80px;\n    gap: 40px;\n}\n\n/* ---------- Header ---------- */\n.landing-header {\n    position: sticky;\n    top: 0;\n    z-index: 100;\n    background: #ffffff;\n    border-bottom: 1px solid transparent;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 20px 24px;\n    box-sizing: border-box;\n}\n\n.landing-header__logo {\n    display: flex;\n    align-items: center;\n    text-decoration: none;\n    color: inherit;\n    cursor: pointer;\n    background: none;\n    border: none;\n    padding: 0;\n}\n\n.landing-header__logo-img {\n    height: 32px;\n    width: auto;\n    display: block;\n}\n\n.landing-header__nav {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.landing-header__station {\n    display: inline-flex;\n    align-items: center;\n    margin-right: 4px;\n    background: none;\n    border: none;\n    padding: 0;\n    cursor: pointer;\n}\n\n.landing-header__station-img {\n    height: 18px;\n    width: auto;\n    display: block;\n}\n\n.landing-header__nav-btn {\n    background: #ffffff;\n    border: none;\n    min-height: 32px;\n    padding: 4px 8px;\n    border-radius: 4px;\n    font-family: var(--font-sans);\n    font-weight: 500;\n    font-size: 14px;\n    color: var(--fg-text-basic);\n    cursor: pointer;\n    transition: background var(--transition-fast);\n}\n\n.landing-header__nav-btn:hover {\n    background: #f8f8f8;\n}\n\n.landing-header__nav-btn--active {\n    background: #f8f8f8;\n}\n\n.landing-header__login {\n    background: var(--fg-bg-litepp);\n    border: none;\n    height: 32px;\n    padding: 5px 7px 7px;\n    border-radius: 4px;\n    font-family: var(--font-sans);\n    font-weight: 600;\n    font-size: 13px;\n    color: var(--fg-button-hover);\n    cursor: pointer;\n    transition: background var(--transition-fast);\n}\n\n.landing-header__login:hover {\n    background: var(--fg-bg-litepp-hover);\n}\n\n/* 햄버거 / 닫기 버튼 / 백드롭 — 데스크탑에서는 모두 숨김 */\n.landing-header__burger,\n.landing-header__close,\n.landing-header__backdrop {\n    display: none;\n}\n\n.landing-header__burger {\n    background: none;\n    border: none;\n    padding: 6px;\n    margin: -6px;\n    color: var(--fg-text-basic);\n    cursor: pointer;\n    line-height: 0;\n    border-radius: var(--radius-md);\n}\n\n.landing-header__burger:hover {\n    background: #f8f8f8;\n}\n\n/* ---------- Header · 모바일 (우측 슬라이드 드로어) ---------- */\n@media (max-width: 640px) {\n    .landing-header { padding: 12px 16px; }\n    .landing-header__logo-img { height: 26px; }\n\n    .landing-header__burger {\n        display: inline-flex;\n    }\n\n    /* 반투명 백드롭 — 열렸을 때만 페이드 인 */\n    .landing-header__backdrop {\n        display: block;\n        position: fixed;\n        inset: 0;\n        z-index: 110;\n        border: none;\n        background: rgba(20, 24, 40, 0.4);\n        opacity: 0;\n        visibility: hidden;\n        transition: opacity 0.25s ease, visibility 0.25s ease;\n        cursor: default;\n    }\n\n    .landing-header__backdrop.is-open {\n        opacity: 1;\n        visibility: visible;\n    }\n\n    /* nav → 우측 드로어 패널 */\n    .landing-header__nav {\n        position: fixed;\n        top: 0;\n        right: 0;\n        z-index: 120;\n        flex-direction: column;\n        align-items: stretch;\n        gap: 4px;\n        width: min(78vw, 300px);\n        height: 100%;\n        padding: 64px 16px 24px;\n        box-sizing: border-box;\n        background: #ffffff;\n        box-shadow: var(--shadow-xl);\n        transform: translateX(100%);\n        transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);\n        overflow-y: auto;\n    }\n\n    .landing-header__nav.is-open {\n        transform: translateX(0);\n    }\n\n    .landing-header__close {\n        display: inline-flex;\n        position: absolute;\n        top: 14px;\n        right: 14px;\n        background: none;\n        border: none;\n        padding: 6px;\n        color: var(--fg-text-gray);\n        cursor: pointer;\n        line-height: 0;\n        border-radius: var(--radius-md);\n    }\n\n    .landing-header__close:hover {\n        background: #f8f8f8;\n    }\n\n    .landing-header__nav-btn {\n        justify-content: flex-start;\n        text-align: left;\n        width: 100%;\n        min-height: 48px;\n        padding: 12px 14px;\n        font-size: 16px;\n        border-radius: var(--radius-md);\n    }\n\n    /* 로그인/홈 — 드로어 하단 풀폭 CTA */\n    .landing-header__login {\n        height: auto;\n        width: 100%;\n        margin-top: 12px;\n        padding: 14px;\n        font-size: 15px;\n        text-align: center;\n    }\n}\n\n/* ---------- Footer ---------- */\n.landing-footer {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    padding: 80px 24px 40px;\n}\n\n.landing-footer__inner {\n    display: flex;\n    gap: 20px;\n    align-items: center;\n    flex-wrap: wrap;\n}\n\n.landing-footer__link {\n    background: none;\n    border: none;\n    padding: 0;\n    font-family: var(--font-sans);\n    font-weight: 400;\n    font-size: 14px;\n    color: var(--fg-text-basic);\n    cursor: pointer;\n    text-decoration: none;\n}\n\n.landing-footer__link:hover {\n    text-decoration: underline;\n}\n\n.landing-footer__copyright {\n    font-family: var(--font-sans);\n    font-weight: 400;\n    font-size: 14px;\n    color: var(--fg-text-basic);\n}\n\n/* ---------- Section 공통 ---------- */\n.landing-section {\n    width: 100%;\n    max-width: 1280px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 40px;\n}\n\n.landing-section--narrow {\n    max-width: 920px;\n}\n\n.landing-section__heading {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    align-items: center;\n    text-align: center;\n    width: 100%;\n}\n\n.landing-section__title {\n    font-family: var(--font-sans);\n    font-weight: 800;\n    font-size: 40px;\n    line-height: 1.2;\n    color: var(--fg-text-basic);\n    margin: 0;\n}\n\n.landing-section__subtitle {\n    font-family: var(--font-sans);\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 28px;\n    color: var(--fg-text-basic);\n    margin: 0;\n}\n\n/* ---------- Button - main S ---------- */\n.landing-btn-s {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n    padding: 8px 8px 8px 12px;\n    background: var(--fg-bg-card);\n    border: 1px solid var(--fg-line);\n    border-radius: 8px;\n    font-family: var(--font-sans);\n    font-weight: 400;\n    font-size: 15px;\n    line-height: 28px;\n    color: var(--fg-text-basic);\n    cursor: pointer;\n    text-decoration: none;\n    transition: background var(--transition-fast);\n}\n\n.landing-btn-s:hover {\n    background: var(--fg-bg-content);\n}\n\n.landing-btn-b {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 20px;\n    background: var(--fg-bg-card);\n    border: 1px solid var(--fg-line);\n    border-radius: 12px;\n    font-family: var(--font-sans);\n    font-weight: 400;\n    font-size: 18px;\n    color: #525252;\n    cursor: pointer;\n    text-decoration: none;\n    transition: background var(--transition-fast);\n}\n\n.landing-btn-b:hover {\n    background: var(--fg-bg-content);\n}\n\n.landing-icon-arr {\n    width: 22px;\n    height: 22px;\n    flex-shrink: 0;\n}\n\n/* ====================================================\n * Home\n * ==================================================== */\n\n.landing-home__hero {\n    width: 100%;\n    max-width: 1280px;\n    display: flex;\n    flex-direction: column;\n    gap: 60px;\n    align-items: center;\n}\n\n.landing-home__hero-visual {\n    position: relative;\n    width: 100%;\n    box-shadow: 0 45px 30px -28px rgba(0, 0, 0, 0.1);\n    border-radius: 16px;\n    overflow: hidden;\n}\n\n.landing-home__hero-visual-img {\n    width: 100%;\n    height: auto;\n    display: block;\n}\n\n.landing-home__hero-intro {\n    width: 100%;\n    max-width: 1280px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 40px;\n}\n\n.landing-home__hero-tagline {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 20px;\n    width: 100%;\n}\n\n.landing-home__hero-title {\n    font-family: var(--font-sans);\n    font-weight: 800;\n    font-size: 40px;\n    line-height: 1.2;\n    color: var(--fg-text-basic);\n    text-align: center;\n    margin: 0;\n}\n\n.landing-home__hero-desc {\n    font-family: var(--font-sans);\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 28px;\n    color: var(--fg-text-basic);\n    text-align: center;\n    margin: 0;\n}\n\n.landing-home__model-row {\n    display: flex;\n    gap: 20px;\n    align-items: center;\n    justify-content: center;\n    flex-wrap: wrap;\n}\n\n.landing-home__model-icon {\n    width: 40px;\n    height: 40px;\n    flex-shrink: 0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--fg-text-basic);\n}\n\n.landing-home__banner-row {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    width: 920px;\n    max-width: 100%;\n}\n\n.landing-home__banner-card {\n    position: relative;\n    min-width: 0;\n    width: 100%;\n    border-radius: var(--radius-2xl);\n    overflow: hidden;\n    background: none;\n    border: none;\n    padding: 0;\n    cursor: pointer;\n    transition: transform var(--transition-fast);\n    display: block;\n}\n\n.landing-home__banner-card:hover {\n    /* transform: translateY(-2px); */\n}\n\n.landing-home__banner-card img {\n    width: 100%;\n    height: auto;\n    display: block;\n}\n\nhtml {\n    scrollbar-gutter: stable;\n}\n\n/* Station 섹션 — 피그마: w-full (전체 너비)\n * .landing__main의 24px 패딩을 깨고 viewport 100%까지 확장 */\n.landing-home__station {\n    width: 100vw;\n    margin-left: calc(50% - 50vw);\n    margin-right: calc(50% - 50vw);\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n    align-items: center;\n}\n\n.landing-home__station>.landing-section__heading {\n    max-width: 1280px;\n    padding: 0 24px;\n    box-sizing: border-box;\n}\n\n.landing-home__station-logo-img {\n    height: 42px;\n    width: auto;\n    display: block;\n}\n\n.landing-home__station-slider {\n    position: relative;\n    width: 100%;\n    max-width: 1840px;\n    margin: 0 auto;\n    overflow: visible;\n}\n\n.landing-home__station-track {\n    display: flex;\n    gap: 32px;\n    justify-content: center;\n    overflow-x: auto;\n    overflow-y: visible;\n    padding: 20px 24px 40px;\n    scroll-snap-type: x mandatory;\n    scrollbar-width: none;\n}\n\n.landing-home__station-track::-webkit-scrollbar {\n    display: none;\n}\n\n.station-card {\n    flex-shrink: 0;\n    width: 280px;\n    height: 540px;\n    padding: 20px;\n    background: #effafa;\n    border-radius: 16px;\n    box-shadow: 0 11px 10.2px -10px rgba(0, 0, 0, 0.16);\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    overflow: hidden;\n    cursor: pointer;\n    transition: transform var(--transition-fast), box-shadow var(--transition-fast), background var(--transition-fast);\n    scroll-snap-align: start;\n    box-sizing: border-box;\n}\n\n.station-card:hover {\n    background: #effbfb;\n    /* box-shadow: 0 34px 26px -20px rgba(0, 0, 0, 0.08);\n    transform: translateY(-2px); */\n}\n\n.station-card__top {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    height: 48px;\n}\n\n.station-card__avatar {\n    width: 48px;\n    height: 48px;\n    display: block;\n    flex-shrink: 0;\n    object-fit: contain;\n}\n\n.station-card__actions {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.station-card__like-count {\n    font-family: var(--font-sans);\n    font-size: 15px;\n    line-height: 28px;\n    color: var(--fg-anti-red);\n}\n\n.station-card__like-btn {\n    width: 32px;\n    height: 32px;\n    padding: 2px;\n    background: transparent;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--fg-text-gray);\n}\n\n.station-card__like-btn--active {\n    color: var(--fg-anti-red);\n}\n\n.station-card__body {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    height: 376px;\n    width: 100%;\n    color: var(--fg-text-basic);\n    overflow: hidden;\n}\n\n.station-card__title {\n    font-family: var(--font-sans);\n    font-weight: 600;\n    font-size: 28px;\n    line-height: 40px;\n    color: var(--fg-text-basic);\n    margin: 0;\n    width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.station-card__smr {\n    font-family: var(--font-sans);\n    font-weight: 400;\n    font-size: 14px;\n    line-height: normal;\n    color: var(--fg-text-basic);\n    margin: 0;\n    width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.landing-home__slider-arr {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 42px;\n    height: 42px;\n    border-radius: 21px;\n    background: var(--fg-bg-card);\n    border: none;\n    box-shadow: 0 2px 3.25px rgba(0, 0, 0, 0.09);\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    z-index: 2;\n    color: var(--fg-text-basic);\n}\n\n.landing-home__slider-arr--left {\n    left: -21px;\n}\n\n.landing-home__slider-arr--right {\n    right: -21px;\n}\n\n/* Foundation/Application/Mastery 섹션 */\n.landing-home__stats {\n    width: 100%;\n    max-width: 1280px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 40px;\n}\n\n.landing-home__stats-list {\n    display: flex;\n    gap: 40px;\n    align-items: flex-start;\n    justify-content: center;\n    flex-wrap: wrap;\n}\n\n.landing-home__stat {\n    min-width: 110px;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    align-items: flex-start;\n}\n\n.landing-home__stat-num {\n    font-family: var(--font-sans);\n    color: var(--fg-button);\n    font-size: 64px;\n    line-height: 1;\n    margin: 0;\n}\n\n.landing-home__stat-num--main {\n    font-weight: 800;\n}\n\n.landing-home__stat-num--unit {\n    font-weight: 100;\n    margin-left: 2px;\n}\n\n.landing-home__stat-label {\n    font-family: var(--font-sans);\n    font-weight: 300;\n    font-size: 20px;\n    color: var(--fg-text-basic);\n    margin: 0;\n}\n\n.landing-home__stages {\n    width: 100%;\n    display: flex;\n    gap: 40px;\n    align-items: flex-start;\n    flex-wrap: wrap;\n}\n\n.landing-stage {\n    flex: 1;\n    min-width: 280px;\n    padding-top: 20px;\n    border-top: 4px solid var(--stage-color, var(--fg-numbering-bg));\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.landing-stage--foundation {\n    --stage-color: var(--fg-numbering-bg);\n}\n\n.landing-stage--application {\n    --stage-color: var(--fg-button);\n}\n\n.landing-stage--mastery {\n    --stage-color: #ff7700;\n}\n\n.landing-stage__label {\n    font-family: var(--font-sans);\n    font-weight: 700;\n    font-size: 14px;\n    color: var(--stage-color);\n    margin: 0;\n}\n\n.landing-stage__title {\n    font-family: var(--font-sans);\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 28px;\n    color: var(--fg-text-basic);\n    margin: 0;\n}\n\n.landing-stage__desc {\n    font-family: var(--font-sans);\n    font-weight: 400;\n    font-size: 15px;\n    line-height: 28px;\n    color: var(--fg-text-basic);\n    margin: 0;\n}\n\n.landing-stage__list {\n    margin: 0;\n    padding-left: 22px;\n    font-family: var(--font-sans);\n    font-weight: 400;\n    font-size: 15px;\n    line-height: 28px;\n    color: var(--fg-text-basic);\n}\n\n/* Features 캐러셀 (그로우핏에서 모든 AI 학습…) */\n.landing-home__features {\n    width: 100%;\n    max-width: 1280px;\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n    align-items: center;\n    position: relative;\n}\n\n.landing-home__feature-slider {\n    position: relative;\n    width: 100%;\n}\n\n.landing-home__feature-viewport {\n    width: 100%;\n    overflow: hidden;\n    border-radius: 16px;\n}\n\n.landing-home__feature-track {\n    display: flex;\n    width: 100%;\n    transition: transform 0.45s cubic-bezier(0.4, 0, 0.2, 1);\n    will-change: transform;\n}\n\n.landing-home__feature-card {\n    flex: 0 0 100%;\n    width: 100%;\n    height: 560px;\n    background: var(--fg-bg-card);\n    display: flex;\n    gap: 32px;\n    overflow: hidden;\n    box-sizing: border-box;\n    border: 1px solid #DBDBDB;\n    border-radius: 16px;\n}\n\n.landing-home__feature-text {\n    width: 400px;\n    flex-shrink: 0;\n    padding: 40px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    align-items: flex-start;\n}\n\n.landing-home__feature-icon {\n    width: 36px;\n    height: 36px;\n    color: var(--fg-button-hover);\n}\n\n.landing-home__feature-title {\n    font-family: var(--font-sans);\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 28px;\n    color: var(--fg-text-basic);\n    margin: 0;\n}\n\n.landing-home__feature-desc {\n    font-family: var(--font-sans);\n    font-weight: 400;\n    font-size: 15px;\n    line-height: 28px;\n    color: var(--fg-text-basic);\n    margin: 0;\n}\n\n.landing-home__feature-tags {\n    display: flex;\n    gap: 4px;\n    flex-wrap: wrap;\n}\n\n.landing-home__feature-tag {\n    background: var(--fg-bg-litepp);\n    padding: 4px 8px;\n    border-radius: 4px;\n    font-family: var(--font-sans);\n    font-weight: 400;\n    font-size: 12px;\n    color: var(--fg-text-basic);\n}\n\n.landing-home__feature-visual {\n    flex: 1;\n    position: relative;\n    background: linear-gradient(135deg, #e8eaf5 0%, #d5d9eb 100%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--fg-button-hover);\n    font-weight: 600;\n    font-size: 18px;\n    padding: 24px;\n    text-align: center;\n    overflow: hidden;\n}\n\n.landing-home__feature-visual-img {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    display: block;\n}\n\n/* Class cards (배우고 이해하고 실습하는 다양한 강의) */\n.landing-classes-grid {\n    width: 100%;\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 20px;\n}\n\n/* ---- Class cards (피그마 1:25014 시안) ----\n * 각 카드는 PNG가 전체 배경. 텍스트는 PNG의 빈 영역에 절대 좌표로 배치.\n * background-image 절대경로 url()은 CRA css-loader 모듈해석을 유발하므로\n * JSX의 inline style로 설정한다. */\n.landing-class-card {\n    position: relative;\n    overflow: hidden;\n    width: 100%;\n    height: 160px;\n    border: none;\n    border-radius: 12px;\n    padding: 0;\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    cursor: pointer;\n    transition: transform var(--transition-fast);\n    text-align: left;\n    color: var(--fg-text-basic);\n    font-family: var(--font-sans);\n}\n\n.landing-class-card:hover {\n    /* transform: translateY(-2px); */\n}\n\n/* 7) 파트너 와이드 배너 (920×200) */\n.landing-class-card--partner {\n    grid-column: 1 / -1;\n    height: 200px;\n}\n\n/* Foundation features 2x3 grid */\n.landing-home__feature-grid {\n    width: 100%;\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 40px;\n}\n\n.feature-tile {\n    padding-top: 20px;\n    border-top: 4px solid var(--tile-color, var(--fg-numbering-bg));\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.feature-tile--cyan {\n    --tile-color: var(--fg-numbering-bg);\n    --tile-bg: #eefcff;\n}\n\n.feature-tile--purple {\n    --tile-color: var(--fg-button);\n    --tile-bg: #f0f2ff;\n}\n\n.feature-tile--green {\n    --tile-color: #abd89c;\n    --tile-bg: #ebf6e7;\n}\n\n.feature-tile--orange {\n    --tile-color: #ff7700;\n    --tile-bg: #fdf3ea;\n}\n\n.feature-tile--blue {\n    --tile-color: #86beff;\n    --tile-bg: #eff5fd;\n}\n\n.feature-tile--pink {\n    --tile-color: #ef8da6;\n    --tile-bg: #ffeff3;\n}\n\n.feature-tile__label {\n    font-family: var(--font-sans);\n    font-weight: 700;\n    font-size: 14px;\n    color: var(--tile-color);\n    margin: 0;\n}\n\n.feature-tile__title {\n    font-family: var(--font-sans);\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 28px;\n    color: var(--fg-text-basic);\n    margin: 0;\n}\n\n.feature-tile__desc {\n    font-family: var(--font-sans);\n    font-weight: 400;\n    font-size: 15px;\n    line-height: 28px;\n    color: var(--fg-text-basic);\n    margin: 0;\n}\n\n.feature-tile__tag {\n    display: inline-flex;\n    align-self: flex-start;\n    background: var(--tile-bg);\n    padding: 4px 8px;\n    border-radius: 4px;\n    font-family: var(--font-sans);\n    font-weight: 400;\n    font-size: 12px;\n    color: var(--fg-text-basic);\n}\n\n/* CTA 배너 */\n.landing-home__cta {\n    width: 100%;\n    max-width: 1280px;\n    background-image: linear-gradient(104deg, #118bad 0%, #402d6e 100%);\n    border-radius: 16px;\n    padding: 60px 40px;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    align-items: center;\n}\n\n.landing-home__cta-title {\n    font-family: var(--font-sans);\n    font-size: 40px;\n    color: #ffffff;\n    text-align: center;\n    margin: 0;\n}\n\n.landing-home__cta-title-weak {\n    font-weight: 200;\n}\n\n.landing-home__cta-title-medium {\n    font-weight: 500;\n}\n\n.landing-home__cta-title-bold {\n    font-weight: 800;\n}\n\n.landing-home__cta-logo {\n    height: 90px;\n    width: auto;\n}\n\n/* ====================================================\n * Notice\n * ==================================================== */\n.landing-notice {\n    width: 100%;\n    max-width: 760px;\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n}\n\n.landing-page-title {\n    font-family: var(--font-sans);\n    font-weight: 600;\n    font-size: 28px;\n    line-height: 40px;\n    color: var(--fg-text-basic);\n    text-align: center;\n    margin: 0;\n}\n\n/* ---------- Legal (이용약관 / 개인정보 처리방침) ---------- */\n.landing-legal {\n    width: 100%;\n    max-width: 760px;\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n}\n\n.landing-legal__head {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.landing-legal__title {\n    font-family: var(--font-sans);\n    font-weight: 600;\n    font-size: 28px;\n    line-height: 40px;\n    color: var(--fg-text-basic);\n    margin: 0;\n}\n\n.landing-legal__help {\n    display: inline-flex;\n    align-items: center;\n    color: var(--fg-text-gray);\n}\n\n.landing-legal__body {\n    width: 100%;\n    font-family: var(--font-sans);\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 26px;\n    color: var(--fg-text-basic);\n    word-break: break-word;\n}\n\n.landing-legal__meta {\n    margin: 0;\n    font-size: 16px;\n    line-height: 26px;\n    color: var(--fg-text-basic);\n}\n\n.landing-legal__body h2 {\n    margin: 28px 0 8px;\n    font-family: var(--font-sans);\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 28px;\n    color: var(--fg-text-basic);\n}\n\n.landing-legal__body h2:first-of-type {\n    margin-top: 8px;\n}\n\n.landing-legal__body p {\n    margin: 0;\n    font-size: 16px;\n    line-height: 26px;\n    color: var(--fg-text-basic);\n}\n\n.landing-legal__body ul {\n    margin: 0;\n    padding-left: 22px;\n    list-style: disc;\n}\n\n.landing-legal__body li {\n    margin: 0;\n    font-size: 16px;\n    line-height: 26px;\n    color: var(--fg-text-basic);\n}\n\n.landing-notice__toolbar {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.landing-category-tabs {\n    display: flex;\n    align-items: center;\n    max-width: 100%;\n    overflow-x: auto;\n    scrollbar-width: none;\n}\n\n.landing-category-tabs::-webkit-scrollbar {\n    display: none;\n}\n\n.landing-category-tab {\n    background: transparent;\n    border: none;\n    border-bottom: 2px solid transparent;\n    padding: 10px;\n    display: inline-flex;\n    align-items: center;\n    gap: 3px;\n    cursor: pointer;\n    font-family: var(--font-sans);\n    flex-shrink: 0;\n    white-space: nowrap;\n}\n\n.landing-category-tab__title {\n    font-weight: 600;\n    font-size: 14px;\n    color: var(--fg-text-basic);\n    margin: 0;\n}\n\n.landing-category-tab__count {\n    font-weight: 400;\n    font-size: 13px;\n    color: var(--fg-text-gray);\n    margin: 0;\n}\n\n.landing-category-tab--active {\n    border-bottom-color: var(--fg-text-basic);\n}\n\n.landing-search {\n    display: inline-flex;\n    align-items: center;\n    justify-content: space-between;\n    background: #ffffff;\n    border: 1px solid var(--fg-line);\n    border-radius: 30px;\n    padding: 7px 12px 7px 20px;\n    width: 240px;\n}\n\n.landing-search__input {\n    flex: 1;\n    border: none;\n    background: transparent;\n    outline: none;\n    font-family: var(--font-sans);\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 26px;\n    color: var(--fg-text-basic);\n    width: calc(100% - 28px);\n}\n\n.landing-search__input::placeholder {\n    color: var(--fg-text-gray);\n}\n\n.landing-search__icon {\n    width: 24px;\n    height: 24px;\n    color: var(--fg-text-gray);\n    flex-shrink: 0;\n}\n\n.landing-notice__list {\n    width: 100%;\n    border-top: 1px solid var(--fg-text-basic);\n    display: flex;\n    flex-direction: column;\n}\n\n.landing-notice__item {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 20px 12px;\n    border-bottom: 1px solid var(--fg-line);\n    background: #ffffff;\n    cursor: pointer;\n    transition: background var(--transition-fast);\n    text-align: left;\n    border-left: none;\n    border-right: none;\n    border-top: none;\n}\n\n.landing-notice__item:hover {\n    background: var(--fg-bg-card);\n}\n\n.landing-notice__item--pinned {\n    background: #f8f9ff;\n}\n\n.landing-notice__meta {\n    width: 136px;\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    text-align: center;\n    align-items: center;\n}\n\n.landing-notice__pin-tag {\n    font-family: var(--font-sans);\n    font-weight: 500;\n    font-size: 14px;\n    color: var(--fg-numbering-bg-current);\n    margin: 0;\n}\n\n.landing-notice__cat {\n    font-family: var(--font-sans);\n    font-weight: 500;\n    font-size: 14px;\n    color: var(--fg-button);\n    margin: 0;\n}\n\n.landing-notice__body {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    min-width: 0;\n}\n\n.landing-notice__title {\n    font-family: var(--font-sans);\n    font-weight: 600;\n    font-size: 16px;\n    color: var(--fg-text-basic);\n    margin: 0;\n}\n\n.landing-notice__smr {\n    font-family: var(--font-sans);\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 22px;\n    color: var(--fg-text-basic);\n    margin: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n}\n\n.landing-notice__date {\n    width: 100px;\n    flex-shrink: 0;\n    text-align: right;\n    font-family: var(--font-sans);\n    font-weight: 400;\n    font-size: 14px;\n    color: var(--fg-text-gray);\n    margin: 0;\n}\n\n/* 리스트 아이템 우측 부가정보(날짜 + 조회수) 컬럼 */\n.landing-notice__aside {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 4px;\n    width: 100px;\n    flex-shrink: 0;\n}\n\n.landing-notice__aside .landing-notice__date {\n    width: auto;\n}\n\n.landing-notice__views {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 12px;\n    color: var(--fg-text-gray);\n}\n\n.landing-notice__share-btn {\n    background: transparent;\n    border: none;\n    width: 28px;\n    height: 28px;\n    padding: 0;\n    margin-left: 4px;\n    border-radius: 4px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    color: var(--fg-text-gray);\n    transition: background var(--transition-fast), color var(--transition-fast);\n}\n\n.landing-notice__share-btn:hover {\n    background: var(--fg-bg-card);\n    color: var(--fg-text-basic);\n}\n\n/* ---------- 공지사항 · 모바일 ---------- */\n@media (max-width: 640px) {\n    /* 본문 컬럼 폭 확보 — 공유 메인 좌우 패딩 축소 */\n    .landing__main,\n    .landing__main--narrow {\n        padding-left: 16px;\n        padding-right: 16px;\n    }\n    /* 리스트 아이템 — 세로 카드로 재배치(고정폭 meta·날짜가 본문을 압박하지 않도록) */\n    .landing-notice__item {\n        flex-direction: column;\n        align-items: stretch;\n        gap: 8px;\n        padding: 16px 10px;\n    }\n    .landing-notice__meta {\n        width: auto;\n        flex-direction: row;\n        align-items: center;\n        justify-content: flex-start;\n        text-align: left;\n        gap: 8px;\n    }\n    /* 날짜·조회수 — 본문 아래 가로 한 줄로 */\n    .landing-notice__aside {\n        width: auto;\n        flex-direction: row;\n        align-items: center;\n        align-self: flex-start;\n        gap: 10px;\n    }\n    .landing-notice__date {\n        text-align: left;\n    }\n    /* 검색창 풀폭 */\n    .landing-search {\n        width: 100%;\n    }\n}\n\n/* 공지 상세 본문 — 관리자 ReactQuill(Quill 2) 에디터 출력과 동일하게 렌더\n * 관리자가 작성한 내용은 getSemanticHTML 결과로 저장되며, 줄바꿈/문단 간격은\n * 에디터(.ql-editor: 14px / line-height 1.6 / 블록요소 margin 0)에 의해 결정됨.\n * 줄바꿈 일치를 위해 동일한 기준값과 margin 모델을 그대로 따른다. */\n.landing-notice__detail-body {\n    font-family: var(--font-sans);\n    font-size: 14px;\n    line-height: 1.6;\n    color: var(--fg-text-basic);\n    word-break: break-word;\n}\n\n/* Quill: 블록 요소는 margin/padding 0 → 줄 간격은 빈 문단(<p><br></p>)으로만 생김 */\n.landing-notice__detail-body p,\n.landing-notice__detail-body ol,\n.landing-notice__detail-body ul,\n.landing-notice__detail-body pre,\n.landing-notice__detail-body blockquote,\n.landing-notice__detail-body h1,\n.landing-notice__detail-body h2,\n.landing-notice__detail-body h3,\n.landing-notice__detail-body h4,\n.landing-notice__detail-body h5,\n.landing-notice__detail-body h6 {\n    margin: 0;\n    padding: 0;\n}\n\n/* 빈 문단(<p></p>) — getSemanticHTML은 빈 줄에서 <br>을 제거하므로 높이가 0이 됨.\n * 에디터의 빈 줄(한 줄 높이)과 동일하게 보이도록 한 줄 높이를 부여 */\n.landing-notice__detail-body p:empty {\n    min-height: 1.6em;\n}\n\n/* Quill 제목 (em 기준 — 14px base) */\n.landing-notice__detail-body h1 {\n    font-size: 2em;\n    font-weight: 700;\n}\n\n.landing-notice__detail-body h2 {\n    font-size: 1.5em;\n    font-weight: 700;\n}\n\n.landing-notice__detail-body h3 {\n    font-size: 1.17em;\n    font-weight: 700;\n}\n\n.landing-notice__detail-body h4 {\n    font-size: 1em;\n    font-weight: 700;\n}\n\n.landing-notice__detail-body h5 {\n    font-size: 0.83em;\n    font-weight: 700;\n}\n\n.landing-notice__detail-body h6 {\n    font-size: 0.67em;\n    font-weight: 700;\n}\n\n/* Quill 리스트 — 불릿은 <ul>(disc), 번호는 <ol>(decimal)로 직렬화됨 */\n.landing-notice__detail-body ol,\n.landing-notice__detail-body ul {\n    padding-left: 1.5em;\n}\n\n.landing-notice__detail-body ul {\n    list-style: disc;\n}\n\n.landing-notice__detail-body ol {\n    list-style: decimal;\n}\n\n.landing-notice__detail-body li[data-list=\"checked\"],\n.landing-notice__detail-body li[data-list=\"unchecked\"] {\n    list-style: none;\n}\n\n.landing-notice__detail-body a {\n    color: var(--fg-link);\n    text-decoration: underline;\n}\n\n.landing-notice__detail-body a:hover {\n    color: var(--fg-link-hover);\n}\n\n.landing-notice__detail-body strong,\n.landing-notice__detail-body b {\n    font-weight: 700;\n}\n\n.landing-notice__detail-body em,\n.landing-notice__detail-body i {\n    font-style: italic;\n}\n\n.landing-notice__detail-body u {\n    text-decoration: underline;\n}\n\n.landing-notice__detail-body s,\n.landing-notice__detail-body del {\n    text-decoration: line-through;\n}\n\n.landing-notice__detail-body mark {\n    background: #fff3a3;\n    padding: 0 2px;\n}\n\n/* Quill blockquote */\n.landing-notice__detail-body blockquote {\n    border-left: 4px solid #ccc;\n    padding-left: 16px;\n    margin: 5px 0;\n    color: var(--fg-text-gray);\n}\n\n/* Quill 코드/코드블록 */\n.landing-notice__detail-body code {\n    background: #f0f0f0;\n    padding: 2px 4px;\n    border-radius: 3px;\n    font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n    font-size: 0.9em;\n}\n\n.landing-notice__detail-body pre {\n    background: #f0f0f0;\n    padding: 5px 10px;\n    border-radius: 3px;\n    margin: 5px 0;\n    overflow-x: auto;\n    white-space: pre-wrap;\n    font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n    font-size: 0.9em;\n}\n\n.landing-notice__detail-body pre code {\n    background: transparent;\n    padding: 0;\n    font-size: inherit;\n}\n\n.landing-notice__detail-body hr {\n    border: 0;\n    border-top: 1px solid var(--fg-line);\n    margin: 16px 0;\n}\n\n.landing-notice__detail-body img {\n    max-width: 100%;\n    height: auto;\n}\n\n/* Quill 표 */\n.landing-notice__detail-body table {\n    border-collapse: collapse;\n}\n\n.landing-notice__detail-body th,\n.landing-notice__detail-body td {\n    border: 1px solid #000;\n    padding: 2px 5px;\n    vertical-align: top;\n}\n\n/* ReactQuill 출력 호환 — align / indent 클래스 (Quill 기본값과 동일) */\n.landing-notice__detail-body .ql-align-center {\n    text-align: center;\n}\n\n.landing-notice__detail-body .ql-align-right {\n    text-align: right;\n}\n\n.landing-notice__detail-body .ql-align-justify {\n    text-align: justify;\n}\n\n.landing-notice__detail-body .ql-indent-1 {\n    padding-left: 3em;\n}\n\n.landing-notice__detail-body .ql-indent-2 {\n    padding-left: 6em;\n}\n\n.landing-notice__detail-body .ql-indent-3 {\n    padding-left: 9em;\n}\n\n.landing-notice__detail-body .ql-indent-4 {\n    padding-left: 12em;\n}\n\n.landing-notice__detail-body .ql-indent-5 {\n    padding-left: 15em;\n}\n\n.landing-notice__detail-body .ql-indent-6 {\n    padding-left: 18em;\n}\n\n.landing-notice__detail-body .ql-indent-7 {\n    padding-left: 21em;\n}\n\n.landing-notice__detail-body .ql-indent-8 {\n    padding-left: 24em;\n}\n\n.landing-notice__detail-body li.ql-indent-1 {\n    padding-left: 4.5em;\n}\n\n.landing-notice__detail-body li.ql-indent-2 {\n    padding-left: 7.5em;\n}\n\n.landing-notice__detail-body li.ql-indent-3 {\n    padding-left: 10.5em;\n}\n\n.landing-notice__detail-body li.ql-indent-4 {\n    padding-left: 13.5em;\n}\n\n.landing-notice__detail-body li.ql-indent-5 {\n    padding-left: 16.5em;\n}\n\n.landing-notice__detail-body li.ql-indent-6 {\n    padding-left: 19.5em;\n}\n\n.landing-notice__detail-body li.ql-indent-7 {\n    padding-left: 22.5em;\n}\n\n.landing-notice__detail-body li.ql-indent-8 {\n    padding-left: 25.5em;\n}\n\n/* 마크다운 폴백 — ReactMarkdown은 빈 문단 없이 <p>만 출력하므로 간격 복원 */\n.landing-notice__detail-body--md p {\n    margin: 12px 0;\n}\n\n.landing-notice__detail-body--md ul,\n.landing-notice__detail-body--md ol {\n    margin: 12px 0;\n}\n\n.landing-notice__detail-body--md h1 {\n    margin: 20px 0 10px;\n}\n\n.landing-notice__detail-body--md h2 {\n    margin: 18px 0 10px;\n}\n\n.landing-notice__detail-body--md h3 {\n    margin: 14px 0 8px;\n}\n\n.landing-notice__detail-body--md h4,\n.landing-notice__detail-body--md h5,\n.landing-notice__detail-body--md h6 {\n    margin: 12px 0 6px;\n}\n\n.landing-notice__detail-body--md blockquote {\n    margin: 12px 0;\n}\n\n.landing-notice__detail-body--md pre {\n    margin: 12px 0;\n}\n\n.landing-notice__detail-body--md>*:first-child {\n    margin-top: 0;\n}\n\n.landing-notice__detail-body--md>*:last-child {\n    margin-bottom: 0;\n}\n\n/* 페이징 */\n.landing-paging {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n}\n\n.landing-paging__btn {\n    min-width: 32px;\n    height: 32px;\n    padding: 4px;\n    background: var(--fg-bg-card);\n    border: 1px solid var(--fg-line);\n    border-radius: 4px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    font-family: var(--font-sans);\n    font-weight: 400;\n    font-size: 15px;\n    line-height: 24px;\n    color: var(--fg-text-gray);\n}\n\n.landing-paging__btn--active {\n    background: var(--fg-button);\n    border-color: var(--fg-button);\n    color: #ffffff;\n}\n\n.landing-paging__btn:disabled {\n    cursor: not-allowed;\n    opacity: 0.5;\n}\n\n.landing-paging__ellipsis {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    height: 32px;\n    color: var(--fg-text-gray);\n    font-size: 14px;\n}\n\n/* ====================================================\n * Price\n * ==================================================== */\n.landing-price {\n    width: 100%;\n    max-width: 920px;\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n}\n\n.landing-price__toggle {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n}\n\n.landing-price__seg {\n    display: inline-flex;\n    align-items: center;\n    gap: 1px;\n    overflow: hidden;\n    border-radius: 4px;\n}\n\n.landing-price__seg-btn {\n    background: var(--fg-bg-litepp);\n    border: none;\n    height: 32px;\n    padding: 5px 12px 7px;\n    font-family: var(--font-sans);\n    font-weight: 600;\n    font-size: 13px;\n    color: var(--fg-button-hover);\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    transition: background var(--transition-fast);\n}\n\n.landing-price__seg-btn--active {\n    background: var(--fg-button);\n    color: #ffffff;\n}\n\n.landing-price__seg-note {\n    font-family: var(--font-sans);\n    font-weight: 500;\n    font-size: 14px;\n    color: var(--fg-side-hover);\n}\n\n.landing-price__plans {\n    width: 100%;\n    display: flex;\n    gap: 20px;\n    align-items: stretch;\n    flex-wrap: wrap;\n}\n\n.landing-plan {\n    flex: 1;\n    min-width: 260px;\n    padding: 20px;\n    background: var(--fg-bg-card);\n    border-radius: 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.landing-plan--featured {\n    background: var(--fg-bg-liteblue);\n}\n\n.landing-plan__role {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.landing-plan__role-icon {\n    width: 20px;\n    height: 20px;\n    color: var(--fg-text-basic);\n}\n\n.landing-plan__role-name {\n    font-family: var(--font-sans);\n    font-weight: 400;\n    font-size: 14px;\n    color: #000000;\n    margin: 0;\n}\n\n.landing-plan__name {\n    font-family: var(--font-sans);\n    font-weight: 600;\n    font-size: 24px;\n    color: var(--fg-text-basic);\n    margin: 0;\n}\n\n.landing-plan__price {\n    display: flex;\n    align-items: flex-end;\n    gap: 4px;\n    color: var(--fg-text-basic);\n}\n\n.landing-plan__price-currency {\n    font-family: var(--font-sans);\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 28px;\n    margin: 0;\n}\n\n.landing-plan__price-amount {\n    font-family: var(--font-sans);\n    font-weight: 600;\n    font-size: 36px;\n    line-height: 46px;\n    margin: 0;\n}\n\n.landing-plan__price-period {\n    font-family: var(--font-sans);\n    font-weight: 400;\n    font-size: 14px;\n    color: var(--fg-text-basic);\n    margin: 0;\n}\n\n.landing-plan__cta {\n    width: 100%;\n    min-height: 44px;\n    padding: 12px;\n    background: var(--fg-button);\n    border: none;\n    border-radius: 8px;\n    color: #ffffff;\n    font-family: var(--font-sans);\n    font-weight: 700;\n    font-size: 16px;\n    cursor: pointer;\n    text-align: center;\n    transition: background var(--transition-fast);\n}\n\n.landing-plan__cta:hover {\n    background: var(--fg-button-hover);\n}\n\n.landing-plan__pitch {\n    font-family: var(--font-sans);\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 26px;\n    color: var(--fg-text-basic);\n    margin: 0;\n}\n\n.landing-plan__features {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n}\n\n.landing-plan__feature {\n    display: flex;\n    gap: 4px;\n    align-items: flex-start;\n    font-family: var(--font-sans);\n    font-weight: 400;\n    font-size: 14px;\n    color: var(--fg-text-basic);\n}\n\n.landing-plan__feature--highlight {\n    font-weight: 500;\n    color: var(--fg-anti-red);\n}\n\n.landing-plan__feature-icon {\n    width: 22px;\n    height: 22px;\n    flex-shrink: 0;\n    color: var(--fg-button);\n}\n\n.landing-plan__feature--highlight .landing-plan__feature-icon {\n    color: var(--fg-anti-red);\n}\n\n/* ====================================================\n * Classes\n * ==================================================== */\n.landing-classes {\n    width: 100%;\n    max-width: 920px;\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n}\n\n.landing-classes__heading {\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.landing-classes__title {\n    font-family: var(--font-sans);\n    font-weight: 600;\n    font-size: 28px;\n    line-height: 40px;\n    color: var(--fg-text-basic);\n    margin: 0;\n}\n\n.landing-classes__subtitle-strong {\n    font-family: var(--font-sans);\n    font-weight: 700;\n    font-size: 18px;\n    line-height: 28px;\n    color: var(--fg-text-basic);\n    margin: 0;\n}\n\n.landing-classes__subtitle {\n    font-family: var(--font-sans);\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 28px;\n    color: var(--fg-text-basic);\n    margin: 0;\n}\n\n.landing-classes__table-toolbar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    height: 42px;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.landing-classes__sort {\n    display: inline-flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 140px;\n    background: #ffffff;\n    border: 1px solid var(--fg-line);\n    border-radius: 8px;\n    padding: 8px 8px 8px 16px;\n    cursor: pointer;\n    font-family: var(--font-sans);\n    font-weight: 400;\n    font-size: 14px;\n    color: var(--fg-text-basic);\n}\n\n.landing-classes__table {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.landing-classes__table-head {\n    display: flex;\n    align-items: center;\n    gap: 24px;\n    padding: 20px;\n    border-bottom: 1px solid var(--fg-text-basic);\n    font-family: var(--font-sans);\n    font-weight: 500;\n    font-size: 14px;\n    color: var(--fg-text-basic);\n    text-align: center;\n}\n\n.landing-classes__th--title {\n    flex: 1;\n    min-width: 0;\n    text-align: left;\n}\n\n.landing-classes__th--instructor {\n    width: 100px;\n}\n\n.landing-classes__th--students {\n    width: 110px;\n}\n\n.landing-classes__row {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    gap: 24px;\n    padding: 20px;\n    border-bottom: 1px solid var(--fg-line);\n    background: #ffffff;\n    cursor: pointer;\n    transition: background var(--transition-fast);\n    text-align: left;\n    border-left: none;\n    border-right: none;\n    border-top: none;\n}\n\n.landing-classes__row:hover {\n    background: var(--fg-bg-card);\n}\n\n.landing-classes__col-title {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.landing-classes__title-row {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.landing-classes__grade-badge {\n    border: 1px solid var(--fg-text-basic);\n    border-radius: 4px;\n    padding: 2px 6px;\n    background: #ffffff;\n    font-family: var(--font-sans);\n    font-weight: 400;\n    font-size: 12px;\n    color: var(--fg-text-basic);\n}\n\n.landing-classes__title-text {\n    font-family: var(--font-sans);\n    font-weight: 600;\n    font-size: 15px;\n    line-height: 28px;\n    color: var(--fg-text-basic);\n}\n\n.landing-classes__smr {\n    font-family: var(--font-sans);\n    font-weight: 400;\n    font-size: 13px;\n    line-height: 20px;\n    color: var(--fg-text-gray);\n    margin: 0;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n}\n\n.landing-classes__col-instructor {\n    width: 100px;\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    overflow: hidden;\n}\n\n.landing-classes__avatar {\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    background: linear-gradient(135deg, var(--fg-bg-litepp), #d8dcf2);\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    color: var(--fg-button-hover);\n    font-weight: 700;\n    font-size: 12px;\n}\n\n.landing-classes__instructor-name {\n    font-family: var(--font-sans);\n    font-weight: 600;\n    font-size: 16px;\n    color: var(--fg-text-basic);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.landing-classes__col-students {\n    width: 110px;\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0;\n    font-family: var(--font-sans);\n    font-size: 14px;\n    color: var(--fg-text-gray);\n    white-space: nowrap;\n}\n\n.landing-classes__students-current {\n    font-weight: 700;\n}\n\n.landing-classes__students-total {\n    font-weight: 400;\n}\n\n/* ====================================================\n * Support\n * ==================================================== */\n.landing-support {\n    width: 100%;\n    max-width: 760px;\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n}\n\n.landing-support__title-row {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    height: 40px;\n}\n\n.landing-support__title {\n    font-family: var(--font-sans);\n    font-weight: 600;\n    font-size: 28px;\n    line-height: 40px;\n    color: var(--fg-text-basic);\n    margin: 0;\n}\n\n.landing-support__title-help {\n    width: 20px;\n    height: 20px;\n    color: var(--fg-text-gray);\n    cursor: pointer;\n}\n\n.landing-support__body {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.landing-support__group {\n    background: var(--fg-line);\n    border: 1px solid var(--fg-line);\n    border-radius: 12px;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    gap: 1px;\n}\n\n.landing-support__row {\n    background: #ffffff;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 16px;\n}\n\n.landing-support__row-icon {\n    width: 28px;\n    height: 28px;\n    color: var(--fg-text-basic);\n    flex-shrink: 0;\n}\n\n.landing-support__row-body {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    min-width: 0;\n}\n\n.landing-support__row-title {\n    font-family: var(--font-sans);\n    font-weight: 600;\n    font-size: 16px;\n    color: var(--fg-text-basic);\n    margin: 0;\n}\n\n.landing-support__row-desc {\n    font-family: var(--font-sans);\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 22px;\n    color: var(--fg-text-basic);\n    margin: 0;\n}\n\n.landing-support__row-cta {\n    background: var(--fg-bg-litepp);\n    border: none;\n    height: 32px;\n    padding: 5px 7px 7px;\n    border-radius: 4px;\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    font-family: var(--font-sans);\n    font-weight: 600;\n    font-size: 13px;\n    color: var(--fg-button-hover);\n    cursor: pointer;\n    text-decoration: none;\n    flex-shrink: 0;\n}\n\n.landing-support__row-cta-icon {\n    width: 16px;\n    height: 16px;\n}\n\n.landing-support__faq-title {\n    font-family: var(--font-sans);\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 26px;\n    color: var(--fg-text-basic);\n    margin: 0;\n}\n\n.landing-support__accordion {\n    background: var(--fg-line);\n    border: 1px solid var(--fg-line);\n    border-radius: 12px;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    gap: 1px;\n}\n\n.landing-support__accordion-item {\n    background: #ffffff;\n    border: none;\n    padding: 16px;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    min-height: 52px;\n    cursor: pointer;\n    text-align: left;\n    transition: background var(--transition-fast);\n    font-family: var(--font-sans);\n}\n\n.landing-support__accordion-item:hover {\n    background: var(--fg-bg-card);\n}\n\n.landing-support__accordion-item--open {\n    background: #f3fbff;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 20px;\n}\n\n.landing-support__accordion-q {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    width: 100%;\n}\n\n.landing-support__accordion-q-text {\n    flex: 1;\n    font-family: var(--font-sans);\n    font-weight: 500;\n    font-size: 14px;\n    color: var(--fg-text-basic);\n    margin: 0;\n}\n\n.landing-support__accordion-chev {\n    width: 20px;\n    height: 20px;\n    color: var(--fg-text-basic);\n    flex-shrink: 0;\n    transition: transform var(--transition-fast);\n}\n\n.landing-support__accordion-item--open .landing-support__accordion-chev {\n    transform: rotate(180deg);\n}\n\n.landing-support__accordion-a {\n    font-family: var(--font-sans);\n    font-weight: 400;\n    font-size: 13px;\n    line-height: 22px;\n    color: var(--fg-text-gray);\n    margin: 0;\n    text-align: left;\n}\n\n.landing-support__brand {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    width: 100%;\n}\n\n.landing-support__brand-logos {\n    display: flex;\n    gap: 20px;\n    align-items: center;\n}\n\n.landing-support__brand-logo {\n    height: 36px;\n    width: auto;\n}\n\n.landing-support__brand-logo--bct {\n    height: 24px;\n}\n\n.landing-support__brand-desc {\n    font-family: var(--font-sans);\n    font-weight: 500;\n    font-size: 14px;\n    color: var(--fg-text-basic);\n    margin: 0;\n}\n\n.landing-support__brand-desc strong {\n    font-weight: 700;\n}\n\n.landing-support__brand-copyright {\n    font-family: var(--font-sans);\n    font-weight: 400;\n    font-size: 14px;\n    color: var(--fg-text-basic);\n    margin: 0;\n}\n\n/* Kakao 문의 FAB & 모달 */\n.landing-home__kakao-fab {\n    position: fixed;\n    right: 24px;\n    bottom: 24px;\n    width: 64px;\n    height: 64px;\n    border-radius: var(--radius-full);\n    background: none;\n    border: none;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 90;\n    transition: transform var(--transition-fast);\n}\n\n.landing-home__kakao-fab:hover {\n    transform: translateY(-2px);\n}\n\n.landing-home__kakao-fab:focus-visible {\n    outline: none;\n    box-shadow: var(--focus-ring);\n}\n\n.landing-home__kakao-fab-icon {\n    width: 32px;\n    height: 32px;\n    object-fit: contain;\n}\n\n.landing-home__kakao-modal {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.6);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 100;\n    padding: 16px;\n    animation: landing-kakao-fade 0.15s ease-out;\n}\n\n@keyframes landing-kakao-fade {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n.landing-home__kakao-modal-body {\n    position: relative;\n    background: var(--surface);\n    padding: 32px 32px 24px;\n    border-radius: var(--radius-2xl);\n    box-shadow: var(--shadow-2xl);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 16px;\n    max-width: 100%;\n}\n\n.landing-home__kakao-modal-close {\n    position: absolute;\n    top: 12px;\n    right: 12px;\n    width: 32px;\n    height: 32px;\n    background: none;\n    border: none;\n    border-radius: var(--radius-md);\n    cursor: pointer;\n    color: var(--text-secondary);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background var(--transition-fast), color var(--transition-fast);\n}\n\n.landing-home__kakao-modal-close:hover {\n    background: var(--gray-100);\n    color: var(--text-primary);\n}\n\n.landing-home__kakao-modal-title {\n    margin: 0;\n    font-size: 18px;\n    font-weight: 700;\n    color: var(--text-primary);\n}\n\n.landing-home__kakao-modal-img {\n    width: 280px;\n    height: 280px;\n    object-fit: contain;\n    display: block;\n}\n\n.landing-home__kakao-modal-desc {\n    margin: 0;\n    font-size: 14px;\n    color: var(--text-secondary);\n}\n\n/* ====================================================\n * Home(LandingHome) 반응형 — 태블릿/모바일\n * landing-home__* 계열은 기본이 데스크탑 고정값(폰트 40~64px,\n * feature-grid 3열 고정 등)이라 좁은 폭에서 그리드 열·폰트·여백을\n * 단계적으로 축소한다.\n * ==================================================== */\n\n/* 태블릿: 커리큘럼 그리드 3 → 2열 */\n@media (max-width: 980px) {\n    .landing-home__feature-grid {\n        grid-template-columns: repeat(2, 1fr);\n        gap: 28px;\n    }\n}\n\n@media (max-width: 640px) {\n    /* 섹션 간 간격 축소 (데스크탑 160px → 모바일 80px) */\n    .landing__main {\n        gap: 80px;\n    }\n\n    /* 섹션/히어로 제목·부제 — 40px 고정값은 모바일에서 넘침 */\n    .landing-section__title {\n        font-size: 26px;\n    }\n\n    .landing-section__subtitle {\n        font-size: 15px;\n        line-height: 24px;\n    }\n\n    .landing-home__hero {\n        gap: 36px;\n    }\n\n    .landing-home__hero-intro {\n        gap: 28px;\n    }\n\n    .landing-home__hero-title {\n        font-size: 26px;\n    }\n\n    .landing-home__hero-desc {\n        font-size: 15px;\n        line-height: 24px;\n    }\n\n    .landing-home__model-row {\n        gap: 14px;\n    }\n\n    /* 통계 — 64px 숫자는 모바일에서 과대, 각 항목 중앙 정렬 */\n    .landing-home__stats-list {\n        gap: 24px 28px;\n    }\n\n    .landing-home__stat {\n        min-width: 0;\n        align-items: center;\n        text-align: center;\n    }\n\n    .landing-home__stat-num {\n        font-size: 44px;\n    }\n\n    .landing-home__stat-label {\n        font-size: 16px;\n    }\n\n    /* 스테이지 카드 간격 */\n    .landing-home__stages {\n        gap: 28px;\n    }\n\n    /* 커리큘럼 그리드 — 모바일 1열 (기존 repeat(3,1fr) 고정 해제) */\n    .landing-home__feature-grid {\n        grid-template-columns: 1fr;\n        gap: 24px;\n    }\n\n    /* CTA 배너 */\n    .landing-home__cta {\n        padding: 40px 20px;\n    }\n\n    .landing-home__cta-title {\n        font-size: 26px;\n    }\n\n    .landing-home__cta-logo {\n        height: 60px;\n    }\n\n    /* 카카오 FAB·QR 모달 — 작은 화면 가로 오버플로 방지 */\n    .landing-home__kakao-fab {\n        right: 16px;\n        bottom: 16px;\n        width: 56px;\n        height: 56px;\n    }\n\n    .landing-home__kakao-modal-body {\n        padding: 28px 20px 20px;\n    }\n\n    .landing-home__kakao-modal-img {\n        width: 220px;\n        height: 220px;\n    }\n\n    /* 둘러보기 슬라이더 — 데스크탑 가로 분할(텍스트 400px + 이미지)을\n       모바일에서 세로 스택으로 전환. 고정 400px 텍스트가 줄지 않아\n       이미지를 화면 밖으로 밀어내던 문제 해결 */\n    .landing-home__feature-card {\n        flex-direction: column;\n        height: auto;\n        gap: 0;\n    }\n\n    .landing-home__feature-text {\n        width: auto;\n        padding: 24px;\n    }\n\n    .landing-home__feature-visual {\n        flex: none;\n        width: 100%;\n        height: 200px;\n    }\n\n    /* 화살표 — 뷰포트 밖(-21px)으로 나가 잘리던 것을 안쪽으로,\n       이미지 영역(하단 200px) 세로 중앙에 배치 */\n    .landing-home__slider-arr {\n        top: auto;\n        bottom: 82px;\n        transform: none;\n        width: 36px;\n        height: 36px;\n    }\n\n    .landing-home__slider-arr--left {\n        left: 8px;\n    }\n\n    .landing-home__slider-arr--right {\n        right: 8px;\n    }\n}\n\n/* ── 랜딩 리포지셔닝: 브랜드 네이비 로컬 토큰 ──\n   제품(AgentShowcase .gf-showcase-page)과 동일한 브랜드 네이비를 랜딩 로컬로 정의.\n   전역 토큰은 변경하지 않는다(보라 계열 primary / fg-purple 토큰 미사용). */\n.landing {\n  --lp-navy: #13314f;        /* 브랜드 네이비 */\n  --lp-navy-ink: #0e1b2b;    /* 다크 밴드 배경용 near-black 네이비 */\n  --lp-navy-soft: #3c5a78;   /* 보조 네이비 */\n  --lp-navy-tint: #e7edf3;   /* 배지 등 옅은 네이비 배경 */\n  --lp-navy-line: rgba(14, 27, 43, 0.1);  /* 헤어라인 */\n  --lp-gov: #1a5e3a;         /* 정부 공급기업 그린 */\n  --lp-gov-tint: #e6f1ea;\n  --lp-serif: \"Newsreader\", \"Iowan Old Style\", Georgia, serif;  /* 에디토리얼 숫자 */\n}\n\n/* ── 랜딩 리포지셔닝: 히어로 ── */\n.lp-hero {\n  padding: 84px 24px 80px;\n  background: var(--fg-bg-content, var(--surface));\n}\n.lp-hero__inner {\n  max-width: 880px;\n  margin: 0 auto;\n  text-align: center;\n}\n.lp-hero__eyebrow {\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  color: var(--lp-navy-soft);\n  margin: 0 0 16px;\n}\n.lp-hero__title {\n  font-size: 44px;\n  line-height: 1.25;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: var(--text-primary);\n  margin: 0 0 20px;\n}\n.lp-hero__title-accent {\n  color: var(--lp-navy);\n}\n.lp-hero__desc {\n  font-size: 18px;\n  line-height: 1.6;\n  color: var(--text-secondary);\n  margin: 0 auto 32px;\n  max-width: 700px;\n}\n.lp-hero__cta {\n  margin: 0 auto;\n}\n.lp-hero__trust {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 14px;\n  margin-top: 40px;\n  flex-wrap: wrap;\n}\n.lp-hero__trust-label {\n  font-size: 13px;\n  color: var(--text-tertiary);\n}\n.lp-hero__trust-list {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n.lp-hero__trust-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-decoration: none;\n  cursor: pointer;\n  padding: 6px 14px 6px 10px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-full);\n  background: var(--background);\n  transition: border-color var(--transition-fast), color var(--transition-fast), box-shadow var(--transition-fast);\n}\n.lp-hero__trust-item:hover {\n  color: var(--lp-navy);\n  border-color: var(--lp-navy-soft);\n  box-shadow: var(--shadow-sm);\n}\n.lp-hero__trust-ic {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  flex: none;\n  border-radius: 4px;\n  background: var(--lp-navy-tint);\n  color: var(--lp-navy);\n  font-size: 10px;\n  font-weight: 800;\n  overflow: hidden;\n}\n.lp-hero__trust-ic img {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  background: #fff;\n}\n\n/* 히어로 제품 앵커 — 매칭 결과 윈도우 목업 */\n.lp-hero__product {\n  max-width: 760px;\n  margin: 52px auto 0;\n}\n.lp-hero__window {\n  border-radius: 16px;\n  overflow: hidden;\n  background: #fff;\n  border: 1px solid var(--lp-navy-line);\n  box-shadow: 0 44px 72px -40px rgba(14, 27, 43, 0.5);\n  text-align: left;\n}\n.lp-hero__window-bar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 18px;\n  background: var(--lp-navy);\n}\n.lp-hero__window-dots { display: inline-flex; gap: 6px; }\n.lp-hero__window-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.32);\n}\n.lp-hero__window-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.92);\n}\n.lp-hero__window-body { padding: 20px 22px 18px; }\n.lp-hero__rtabs { display: flex; gap: 8px; margin-bottom: 16px; }\n.lp-hero__rtab {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--text-tertiary);\n  padding: 7px 13px;\n  border-radius: var(--radius-full);\n  border: 1px solid var(--lp-navy-line);\n}\n.lp-hero__rtab b { font-weight: 800; }\n.lp-hero__rtab.is-on {\n  color: #fff;\n  background: var(--lp-navy);\n  border-color: var(--lp-navy);\n}\n.lp-hero__rlist {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n}\n.lp-hero__rrow {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 13px 4px;\n  border-top: 1px solid var(--lp-navy-line);\n}\n.lp-hero__rrow:first-child { border-top: none; }\n.lp-hero__rdot {\n  flex: none;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--lp-gov);\n}\n.lp-hero__rmain { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 2px; }\n.lp-hero__rname { font-size: 14.5px; font-weight: 700; color: var(--text-primary); }\n.lp-hero__rmeta { font-size: 12.5px; color: var(--text-tertiary); }\n.lp-hero__rdday {\n  flex: none;\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--lp-navy-soft);\n  background: var(--lp-navy-tint);\n  border-radius: var(--radius-full);\n  padding: 5px 11px;\n}\n.lp-hero__rdday--now { color: var(--lp-gov); background: var(--lp-gov-tint); }\n.lp-hero__rfoot {\n  margin-top: 14px;\n  padding-top: 14px;\n  border-top: 1px solid var(--lp-navy-line);\n  font-size: 12px;\n  color: var(--text-tertiary);\n}\n@media (max-width: 640px) {\n  .lp-hero__product { margin-top: 40px; }\n  .lp-hero__window-title { font-size: 12px; }\n  /* 매칭 결과 탭(신청 가능/추가 확인/아깝게 탈락) — 좁은 윈도우에서 한 줄 유지 */\n  .lp-hero__window-body { padding: 16px 16px 14px; }\n  .lp-hero__rtabs { gap: 6px; flex-wrap: nowrap; }\n  .lp-hero__rtab { font-size: 11px; padding: 5px 8px; white-space: nowrap; }\n}\n@media (max-width: 640px) {\n  .lp-hero { padding: 64px 20px 48px; }\n  .lp-hero__title { font-size: 32px; }\n  .lp-hero__desc { font-size: 16px; }\n}\n\n/* ── 랜딩 리포지셔닝: 문제 공감 ── */\n.lp-pain {\n  padding: 56px 24px;\n  background: var(--lp-navy-ink);\n}\n.lp-pain__inner {\n  max-width: 720px;\n  margin: 0 auto;\n  text-align: center;\n}\n.lp-pain__lead {\n  font-size: 26px;\n  font-weight: 700;\n  line-height: 1.4;\n  color: #fff;\n  margin: 0 0 12px;\n}\n.lp-pain__sub {\n  font-size: 16px;\n  line-height: 1.6;\n  color: var(--gray-300, rgba(255, 255, 255, 0.72));\n  margin: 0;\n}\n@media (max-width: 640px) {\n  .lp-pain__lead { font-size: 21px; }\n}\n\n/* ── 랜딩 리포지셔닝: 공용 섹션 헤더 ── */\n.lp-section-head {\n  max-width: 720px;\n  margin: 0 auto 40px;\n  text-align: center;\n}\n.lp-section-title {\n  font-size: 32px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: var(--text-primary);\n  margin: 0 0 14px;\n}\n.lp-section-sub {\n  font-size: 16px;\n  line-height: 1.6;\n  color: var(--text-secondary);\n  margin: 0;\n}\n\n/* ── 랜딩 리포지셔닝: 에이전트 라인업 ── */\n.lp-agents {\n  padding: 80px 24px;\n  background: var(--fg-bg-content, var(--surface));\n}\n.lp-agents__grid {\n  max-width: 1140px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 22px;\n}\n@media (max-width: 980px) {\n  .lp-agents__grid { grid-template-columns: 1fr; max-width: 460px; }\n}\n.lp-agent-card {\n  display: flex;\n  flex-direction: column;\n  background: var(--fg-bg-card, var(--background));\n  border: 1px solid var(--border);\n  border-radius: var(--radius-2xl);\n  padding: 28px;\n  box-shadow: var(--shadow-sm);\n  transition: box-shadow var(--transition-fast), transform var(--transition-fast);\n}\n.lp-agent-card:hover {\n  box-shadow: var(--shadow-lg);\n  transform: translateY(-3px);\n}\n.lp-agent-card__name {\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0 0 12px;\n}\n.lp-agent-card__tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 14px;\n}\n.lp-agent-card__tag {\n  font-size: 12px;\n  color: var(--text-secondary);\n  background: var(--gray-100, var(--surface));\n  border-radius: var(--radius-sm);\n  padding: 4px 10px;\n}\n.lp-agent-card__one {\n  font-size: 15px;\n  line-height: 1.65;\n  color: var(--text-secondary);\n  margin: 0 0 16px;\n}\n.lp-agent-card__moat {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.5;\n  color: var(--text-primary);\n  margin: 0 0 20px;\n}\n.lp-agent-card__moat-dot {\n  flex: none;\n  width: 8px;\n  height: 8px;\n  margin-top: 6px;\n  border-radius: var(--radius-full);\n  background: var(--success, var(--fg-class-green));\n}\n.lp-agent-card__samples {\n  margin-bottom: 24px;\n}\n.lp-agent-card__samples-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-tertiary);\n  margin: 0 0 10px;\n}\n.lp-agent-card__samples-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.lp-agent-card__sample {\n  font-size: 13px;\n  line-height: 1.45;\n  color: var(--text-secondary);\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 9px 12px;\n}\n.lp-agent-card__cta {\n  margin-top: auto;\n  border: none;\n  cursor: pointer;\n  font-size: 15px;\n  font-weight: 600;\n  color: #fff;\n  background: var(--lp-navy);\n  border-radius: var(--radius-lg);\n  padding: 13px 18px;\n  transition: background var(--transition-fast);\n}\n.lp-agent-card__cta:hover {\n  background: var(--lp-navy-ink);\n}\n@media (max-width: 760px) {\n  .lp-agents { padding: 56px 20px; }\n  .lp-agents__grid { grid-template-columns: 1fr; }\n}\n\n/* ── 랜딩 리포지셔닝: 작동 방식 ── */\n.lp-how {\n  padding: 80px 24px;\n  background: var(--background);\n}\n.lp-how__steps {\n  max-width: 960px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 24px;\n}\n.lp-how__step {\n  background: var(--fg-bg-card, var(--surface));\n  border: 1px solid var(--border);\n  border-radius: var(--radius-xl);\n  padding: 28px 24px;\n}\n.lp-how__step-no {\n  display: inline-block;\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--lp-navy);\n  margin-bottom: 14px;\n}\n.lp-how__step-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0 0 10px;\n}\n.lp-how__step-desc {\n  font-size: 14px;\n  line-height: 1.65;\n  color: var(--text-secondary);\n  margin: 0;\n}\n@media (max-width: 760px) {\n  .lp-how { padding: 56px 20px; }\n  .lp-how__steps { grid-template-columns: 1fr; }\n}\n\n/* ── 랜딩 리포지셔닝: 해자 ── */\n.lp-moat {\n  padding: 80px 24px;\n  background: var(--fg-bg-content, var(--surface));\n}\n.lp-moat__grid {\n  max-width: 960px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n}\n.lp-moat__item {\n  background: var(--background);\n  border: 1px solid var(--border);\n  border-left: 3px solid var(--lp-navy);\n  border-radius: var(--radius-lg);\n  padding: 24px;\n}\n.lp-moat__item-title {\n  font-size: 17px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0 0 10px;\n}\n.lp-moat__item-desc {\n  font-size: 14px;\n  line-height: 1.65;\n  color: var(--text-secondary);\n  margin: 0;\n}\n@media (max-width: 760px) {\n  .lp-moat { padding: 56px 20px; }\n  .lp-moat__grid { grid-template-columns: 1fr; }\n}\n\n/* ── 랜딩 리포지셔닝: 최종 CTA ── */\n.lp-cta {\n  padding: 88px 24px;\n  background: var(--lp-navy-ink);\n}\n.lp-cta__inner {\n  max-width: 640px;\n  margin: 0 auto;\n  text-align: center;\n}\n.lp-cta__title {\n  font-size: 32px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: #fff;\n  margin: 0 0 14px;\n}\n.lp-cta__desc {\n  font-size: 16px;\n  line-height: 1.6;\n  color: var(--gray-300, rgba(255, 255, 255, 0.72));\n  margin: 0 0 28px;\n}\n.lp-cta__logo {\n  height: 36px;\n  width: auto;\n  object-fit: contain;\n  margin: 0 auto 28px;\n  display: block;\n}\n@media (max-width: 640px) {\n  .lp-cta { padding: 64px 20px; }\n  .lp-cta__title { font-size: 24px; }\n}\n\n/* ── 마지막 화면: CTA + 푸터 통합 (다크 마무리) ──\n   데스크탑(풀페이지)에서는 CTA 콘텐츠를 중앙에, 푸터를 화면 하단에 고정.\n   푸터는 다크 네이비 배경에 맞춰 밝게 반전한다. */\n@media (min-width: 761px) {\n  .lp-cta { position: relative; }\n  .lp-cta > .landing-footer {\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n  }\n}\n.lp-cta > .landing-footer {\n  padding: 22px 24px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n.lp-cta .landing-footer__link { color: rgba(255, 255, 255, 0.72); }\n.lp-cta .landing-footer__link:hover { color: #fff; text-decoration: underline; }\n.lp-cta .landing-footer__copyright { color: rgba(255, 255, 255, 0.5); }\n\n/* ════════════════════════════════════════════════════════\n   랜딩 리포지셔닝 v2 — 실서비스 확장 (모델·비교 / 3 에이전트 / 플랜 / FAQ)\n   다크 네이비 에디토리얼 톤. 풀블리드 밴드 + 세리프 숫자 액센트.\n   ════════════════════════════════════════════════════════ */\n\n/* 홈 전용: 공유 .landing__main 의 gap/padding/center 리셋 → 섹션이 풀폭 밴드를 직접 제어 */\n.lp-main {\n  gap: 0;\n  padding: 0;\n  align-items: stretch;\n}\n\n/* 공용 버튼 시스템 */\n.lp-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  font-family: var(--font-sans);\n  font-weight: 600;\n  font-size: 15px;\n  line-height: 1;\n  border: 1px solid transparent;\n  border-radius: 10px;\n  padding: 12px 20px;\n  cursor: pointer;\n  text-decoration: none;\n  transition: background var(--transition-fast), border-color var(--transition-fast), color var(--transition-fast), transform var(--transition-fast);\n}\n.lp-btn:active { transform: translateY(1px); }\n.lp-btn--lg { padding: 15px 28px; font-size: 16px; }\n.lp-btn--primary { background: var(--lp-navy); color: #fff; }\n.lp-btn--primary:hover { background: var(--lp-navy-ink); }\n.lp-btn--outline { background: #fff; color: var(--lp-navy); border-color: var(--lp-navy); }\n.lp-btn--outline:hover { background: var(--lp-navy-tint); }\n.lp-btn--ghost { background: transparent; color: var(--lp-navy); border-color: var(--lp-navy-line); }\n.lp-btn--ghost:hover { background: var(--lp-navy-tint); border-color: var(--lp-navy-soft); }\n.lp-btn--invert { background: #fff; color: var(--lp-navy); }\n.lp-btn--invert:hover { background: var(--lp-navy-tint); }\n\n/* 공용 eyebrow */\n.lp-eyebrow {\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--lp-navy-soft);\n  margin: 0 0 14px;\n}\n\n/* 히어로 액션 행 */\n.lp-hero__actions {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n/* ── 모델 & 비교 ── */\n.lp-models {\n  padding: 88px 24px;\n  background: var(--background);\n}\n.lp-model-wall {\n  list-style: none;\n  margin: 0 auto 44px;\n  padding: 0;\n  max-width: 920px;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 10px;\n}\n.lp-model-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 9px 16px 9px 12px;\n  background: #fff;\n  border: 1px solid var(--lp-navy-line);\n  border-radius: var(--radius-full);\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--lp-navy);\n  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);\n}\n.lp-model-chip:hover {\n  border-color: var(--lp-navy-soft);\n  box-shadow: var(--shadow-sm);\n}\n.lp-model-chip__logo {\n  display: inline-flex;\n  width: 24px;\n  height: 24px;\n  align-items: center;\n  justify-content: center;\n}\n.lp-model-chip--more {\n  color: var(--lp-navy-soft);\n  background: var(--lp-navy-tint);\n  border-color: transparent;\n}\n\n/* 비교 미리보기 카드 */\n.lp-compare {\n  max-width: 920px;\n  margin: 0 auto;\n  background: #fff;\n  border: 1px solid var(--lp-navy-line);\n  border-radius: var(--radius-2xl);\n  box-shadow: 0 24px 48px -32px rgba(14, 27, 43, 0.4);\n  overflow: hidden;\n}\n.lp-compare__ask {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 18px 24px;\n  background: var(--lp-navy);\n  color: #fff;\n}\n.lp-compare__ask-label {\n  flex: none;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.6);\n  border: 1px solid rgba(255, 255, 255, 0.25);\n  border-radius: var(--radius-full);\n  padding: 4px 10px;\n}\n.lp-compare__ask-text { font-size: 15px; font-weight: 500; }\n.lp-compare__grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n}\n.lp-compare__col {\n  padding: 22px 22px 26px;\n  border-left: 1px solid var(--lp-navy-line);\n}\n.lp-compare__col:first-child { border-left: none; }\n.lp-compare__col-head {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n.lp-compare__col-name { font-size: 14px; font-weight: 700; color: var(--lp-navy); }\n.lp-compare__col-text {\n  margin: 0;\n  font-size: 13.5px;\n  line-height: 1.62;\n  color: var(--text-secondary);\n}\n\n/* ── 작동방식: 번호를 에디토리얼 세리프로 ── */\n.lp-how__step-no {\n  display: block;\n  font-family: var(--lp-serif);\n  font-size: 40px;\n  font-weight: 500;\n  line-height: 1;\n  color: var(--lp-navy);\n  margin-bottom: 16px;\n}\n\n/* ── 에이전트: 공급기업 카드 강조 ── */\n.lp-agent-card { position: relative; }\n.lp-agent-card--supplier {\n  border-color: var(--lp-gov);\n  box-shadow: 0 0 0 1px var(--lp-gov), var(--shadow-sm);\n}\n.lp-agent-card__ribbon {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  color: #fff;\n  background: var(--lp-gov);\n  border-radius: var(--radius-full);\n  padding: 5px 11px;\n}\n/* 카드 헤더 로고 — 텍스트 배지 대체 (supplier=모두의 창업 / 그 외=GrowFit) */\n.lp-agent-card__logo {\n  align-self: flex-start;\n  display: block;\n  width: auto;\n  height: 28px;\n  margin-bottom: 16px;\n}\n/* GrowFit 브랜드 로고는 여러 카드에 반복되므로 한 단계 절제 */\n.lp-agent-card__logo--brand {\n  height: 22px;\n}\n\n/* ── 플랜 · 가격 ── */\n.lp-pricing {\n  padding: 88px 24px;\n  background: var(--background);\n}\n.lp-pricing__grid {\n  max-width: 1040px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 22px;\n  align-items: start;\n}\n.lp-plan {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  border: 1px solid var(--lp-navy-line);\n  border-radius: var(--radius-2xl);\n  padding: 30px 26px;\n}\n.lp-plan--featured {\n  border: 1.5px solid var(--lp-navy);\n  box-shadow: 0 28px 56px -34px rgba(14, 27, 43, 0.45);\n}\n.lp-plan__flag {\n  position: absolute;\n  top: -12px;\n  left: 26px;\n  font-size: 12px;\n  font-weight: 700;\n  color: #fff;\n  background: var(--lp-navy);\n  border-radius: var(--radius-full);\n  padding: 5px 13px;\n}\n.lp-plan__name { font-size: 18px; font-weight: 800; color: var(--lp-navy); margin: 0 0 4px; }\n.lp-plan__tagline { font-size: 13px; color: var(--text-tertiary); margin: 0 0 20px; }\n.lp-plan__price {\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n  margin: 0 0 6px;\n}\n.lp-plan__price-num {\n  font-family: var(--lp-serif);\n  font-size: 40px;\n  font-weight: 600;\n  line-height: 1;\n  color: var(--text-primary);\n}\n.lp-plan__price-unit { font-size: 14px; color: var(--text-secondary); }\n.lp-plan__tokens { font-size: 13px; font-weight: 600; color: var(--lp-navy-soft); margin: 0 0 22px; }\n.lp-plan__cta { width: 100%; margin-bottom: 24px; }\n.lp-plan__features { list-style: none; margin: 0; padding: 20px 0 0; border-top: 1px solid var(--lp-navy-line); display: flex; flex-direction: column; gap: 12px; }\n.lp-plan__feature { display: flex; align-items: flex-start; gap: 9px; font-size: 14px; line-height: 1.45; color: var(--text-secondary); }\n.lp-plan__check { flex: none; margin-top: 1px; color: var(--lp-navy); }\n.lp-pricing__note { max-width: 1040px; margin: 26px auto 0; text-align: center; font-size: 12.5px; color: var(--text-tertiary); }\n\n/* ── FAQ ── */\n.lp-faq {\n  padding: 88px 24px;\n  background: var(--fg-bg-content, var(--surface));\n}\n.lp-faq__list { max-width: 920px; margin: 0 auto; }\n.lp-faq__item { border-bottom: 1px solid var(--lp-navy-line); }\n.lp-faq__item:first-child { border-top: 1px solid var(--lp-navy-line); }\n.lp-faq__q {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 22px 4px;\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--text-primary);\n  cursor: pointer;\n  list-style: none;\n}\n.lp-faq__q::-webkit-details-marker { display: none; }\n.lp-faq__icon { flex: none; color: var(--lp-navy-soft); transition: transform var(--transition-fast); }\n.lp-faq__item[open] .lp-faq__icon { transform: rotate(180deg); }\n.lp-faq__a {\n  margin: 0;\n  padding: 0 4px 24px;\n  font-size: 14.5px;\n  line-height: 1.7;\n  color: var(--text-secondary);\n}\n\n/* ── 반응형 ── */\n@media (max-width: 860px) {\n  .lp-pricing__grid { grid-template-columns: 1fr; max-width: 460px; }\n  .lp-plan--featured { order: -1; }\n}\n@media (max-width: 760px) {\n  .lp-models, .lp-pricing, .lp-faq { padding: 60px 20px; }\n  .lp-compare__grid { grid-template-columns: 1fr; }\n  .lp-compare__col { border-left: none; border-top: 1px solid var(--lp-navy-line); }\n  .lp-compare__col:first-child { border-top: none; }\n  .lp-compare__ask { flex-direction: column; align-items: flex-start; gap: 8px; }\n}\n\n/* ── 좁은 화면(≤480) 미세 튜닝 — 타이틀 과대 방지 + CTA 풀폭 스택 ── */\n@media (max-width: 480px) {\n  .lp-hero__title { font-size: 28px; }\n  .lp-section-title { font-size: 26px; }\n  .lp-cta__title { font-size: 22px; }\n  .lp-hero__actions { flex-direction: column; align-items: stretch; }\n  .lp-hero__actions .lp-btn { width: 100%; }\n}\n\n/* ── 스크롤 리빌 ──\n   useScrollReveal 훅이 뷰포트 진입 시 .is-revealed를 부착한다.\n   순차 등장(stagger)은 컴포넌트에서 inline transition-delay로 제어. */\n.lp-reveal {\n  opacity: 0;\n  transform: translateY(20px);\n  transition: opacity 0.6s ease-out, transform 0.6s ease-out;\n}\n.lp-reveal.is-revealed {\n  opacity: 1;\n  transform: none;\n}\n/* 접근성: 모션 비선호 사용자는 등장 애니메이션 없이 즉시 표시 */\n@media (prefers-reduced-motion: reduce) {\n  .lp-reveal {\n    opacity: 1 !important;\n    transform: none !important;\n    transition: none !important;\n  }\n}\n\n/* ── 풀페이지 스크롤 (데스크탑 전용) ──\n   각 섹션 = 1화면. 휠/키 입력은 useFullpageScroll 훅이 가로채\n   한 번에 한 섹션씩 부드럽게(easing) 이동시킨다.\n   CSS scroll-snap은 JS 애니메이션과 충돌하므로 사용하지 않는다.\n   모바일(≤760) / prefers-reduced-motion 에서는 훅이 비활성 → 일반 스크롤. */\n@media (min-width: 761px) {\n  .landing__main.lp-main {\n    padding: 0;\n    align-items: stretch;\n  }\n  .lp-main > section {\n    /* sticky 헤더(64px)를 뺀 실제 가시영역에 맞춰야 콘텐츠가 헤더에 가리지 않음 */\n    min-height: calc(100vh - 64px);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    box-sizing: border-box;\n  }\n  /* flex 컨테이너 안에서는 margin:auto 자식이 콘텐츠 폭으로 줄어든다.\n     직속 자식을 풀폭으로 두어 각자의 max-width+margin auto(중앙 정렬)가 정상 동작하게 한다. */\n  .lp-main > section > * { width: 100%; }\n\n  /* 풀페이지 1화면에 맞춰 여백을 컴팩트화 (히어로·에이전트 잘림 방지) */\n  .lp-hero { padding-top: 24px; padding-bottom: 20px; }\n  .lp-hero__eyebrow { margin-bottom: 10px; }\n  .lp-hero__title { margin-bottom: 14px; }\n  .lp-hero__desc { margin-bottom: 18px; }\n  .lp-hero__product { margin-top: 20px; }\n  .lp-hero__trust { margin-top: 16px; }\n  .lp-hero__rrow { padding-top: 10px; padding-bottom: 10px; }\n  .lp-agents { padding-top: 40px; padding-bottom: 40px; }\n}\n\n/* ── 섹션 네비 (풀페이지 우측 도트) ──\n   데스크탑에서만 표시. 현재 섹션 강조 + hover/포커스 시 이름 라벨. */\n.lp-secnav {\n  position: fixed;\n  top: 50%;\n  right: 22px;\n  transform: translateY(-50%);\n  z-index: 50;\n  display: none;\n}\n@media (min-width: 761px) {\n  .lp-secnav { display: block; }\n}\n.lp-secnav__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 16px;\n}\n.lp-secnav__dot {\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: 5px;\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n.lp-secnav__dot::after {\n  content: '';\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  background: var(--lp-navy-line);\n  transition: background var(--transition-fast), transform var(--transition-fast);\n}\n.lp-secnav__dot:hover::after { background: var(--lp-navy-soft); }\n.lp-secnav__dot.is-active::after {\n  background: var(--lp-navy);\n  transform: scale(1.45);\n}\n.lp-secnav__label {\n  position: absolute;\n  right: calc(100% + 2px);\n  white-space: nowrap;\n  font-size: 12px;\n  font-weight: 600;\n  color: #fff;\n  background: var(--lp-navy);\n  padding: 4px 10px;\n  border-radius: var(--radius-full);\n  opacity: 0;\n  transform: translateX(4px);\n  pointer-events: none;\n  transition: opacity var(--transition-fast), transform var(--transition-fast);\n}\n.lp-secnav__dot:hover .lp-secnav__label,\n.lp-secnav__dot:focus-visible .lp-secnav__label {\n  opacity: 1;\n  transform: translateX(0);\n}\n/* 다크 배경 섹션 위에서는 도트·라벨을 밝게 반전 */\n.lp-secnav.is-on-dark .lp-secnav__dot::after { background: rgba(255, 255, 255, 0.45); }\n.lp-secnav.is-on-dark .lp-secnav__dot:hover::after { background: rgba(255, 255, 255, 0.8); }\n.lp-secnav.is-on-dark .lp-secnav__dot.is-active::after { background: #fff; }\n.lp-secnav.is-on-dark .lp-secnav__label { background: #fff; color: var(--lp-navy); }\n@media (prefers-reduced-motion: reduce) {\n  .lp-secnav__label { transition: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
